<template>
  <div id="divContainer" v-on:click="exitmenu">
    <!-- <TopMenu /> -->
    <!--<section
      @click="onClickHandler"
      id="sectionId"
      class="sponsors-list-wrapper d-flex body-content"
      style="
        background-image: url('https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FBranding%2FEvent%20Background_2732x2048%20pixels.jpg?alt=media');
      "
    >-->
    <section
      @click="onClickHandler"
      id="sectionId"
      class="sponsors-list-wrapper d-flex body-content"
      style="background-color: #f1f3f4"
    >
      <div class="container-fluid mymeeting_new_wpapper">
        <!------top area start--->
        <div class="row">
          <div class="col-md-7 mob-py-0">
            <h1 id="headerText" class="page-head text-uppercase mb-0 mt-3">
              {{ headerText }}
            </h1>
            <h6 id="subHeaderText" class="meeting-time-zone mt-1">
              {{ localTimeZone }}
            </h6>
          </div>
          <div class="col-md-5 text-md-right text-right bookmeeting-btn_wrap">
            <button
              class="blue-button icon-bookmeeting"
              v-on:click="navigate"
              data-tag="bookMeetingNow"
            >
              {{ $t("mymeetings.bookmeeting") }}
            </button>
            <div
              class="right-side-hld d-flex align-items-center justify-content-end"
              style="display: none"
            >
              <div
                class="position-relative fixed-w full-width search-hld"
                style="display: none"
              >
                <form
                  id="newsletter-validate-detail"
                  class="form subscribe"
                  action
                  method
                >
                  <input
                    id="InputSearch"
                    type="text"
                    placeholder="Search.."
                    data-tag="searchMeetingsInput"
                  />
                  <button
                    class="sub-btn"
                    type="submit"
                    data-tag="searchMeetingsSubmit"
                  >
                    {{ $t("mymeetings.search") }}
                  </button>
                </form>
              </div>
              <!-----filter start---->
              <div class="dropdown" style="display: none">
                <button
                  class="ad-btn d-lg-inline-block dropdown-toggle"
                  type="button"
                  id="dropdownMenu2"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    viewBox="0 0 16.5 15"
                  >
                    <path
                      id="filter.svg"
                      fill="#242432"
                      d="M181.241,159.157c0,0.013,0,.025,0,0.037a0.532,0.532,0,0,1,.006.056,0.744,0.744,0,0,1-.284.583L175.25,166.3v6.453h-0.011a0.713,0.713,0,0,1-.082.366,0.747,0.747,0,0,1-1.005.3l-3.023-1.532a0.715,0.715,0,0,1-.368-0.631H170.75V166.3l-5.716-6.463a0.747,0.747,0,0,1-.284-0.584,0.523,0.523,0,0,1,.006-0.057c0-.012,0-0.023,0-0.034a0.736,0.736,0,0,1,.066-0.23c0.008-.017.017-0.033,0.027-0.05A0.722,0.722,0,0,1,165,158.7c0.007-.007.01-0.016,0.018-0.023s0.018-.008.027-0.015a0.748,0.748,0,0,1,.208-0.113l0.057-.017a0.705,0.705,0,0,1,.191-0.028h15a0.705,0.705,0,0,1,.191.028c0.02,0,.038.011,0.058,0.018a0.722,0.722,0,0,1,.206.112c0.009,0.007.02,0.008,0.028,0.015s0.011,0.016.019,0.023a0.75,0.75,0,0,1,.145.182c0.01,0.017.02,0.034,0.029,0.052A0.76,0.76,0,0,1,181.241,159.157Zm-9.172,6.377a0.716,0.716,0,0,1,.169.466h0.012v4.791l1.5,0.76V166h0.012a0.716,0.716,0,0,1,.169-0.466L178.825,160h-11.65Z"
                      transform="translate(-164.75 -158.5)"
                    />
                  </svg>
                  <span class="cart-item"></span>
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenu2">
                  <ul class="filter-listing clearfix remember">
                    <li>
                      <label class="terms_text">
                        {{ $t("mymeetings.all") }}
                        <input type="checkbox" checked />
                        <span class="checkmark"></span>
                      </label>
                    </li>
                    <li>
                      <label class="terms_text">
                        {{ $t("mymeetings.group") }}
                        <input type="checkbox" />
                        <span class="checkmark"></span>
                      </label>
                    </li>
                    <li>
                      <label class="terms_text">
                        {{ $t("mymeetings.meeting") }}
                        <input type="checkbox" />
                        <span class="checkmark"></span>
                      </label>
                    </li>
                  </ul>
                </div>
              </div>
              <!-----filter end---->
            </div>
          </div>
        </div>
        <!------top area end--->
        <!----17.06.2020 meeting tab--->
        <div
          class="meeting-tab session-list-wrapper p-0 d-flex align-items-center justify-content-between"
        >
          <ul
            role="tablist"
            :class="'nav nav-tabs text-uppercase ' + event_collectionName"
          >
            <li class="nav-item">
              <a
                data-toggle="tab"
                href="#Confirmed"
                class="nav-link active"
                data-tag="meetingConfirmed"
              >
                {{ $t("mymeetings.confirmed") }}
                <span id="spConfirm"></span>
              </a>
            </li>
            <li class="nav-item">
              <a
                data-toggle="tab"
                href="#RequestSent"
                class="nav-link"
                data-tag="meetingRequestsend"
              >
                {{ $t("mymeetings.requestsent") }}
                <span id="spReqSent"></span>
              </a>
            </li>
            <li class="nav-item">
              <a
                data-toggle="tab"
                href="#RequestReceived"
                class="nav-link"
                data-tag="meetingRequestReceived"
              >
                {{ $t("mymeetings.requestreceived") }}
                <span id="spReqRec"></span>
              </a>
            </li>
          </ul>
          <!-----grid view---------->
          <!-- <div class="meeding-grid text-right">
            <ul class="d-flex">
              <li
                id="grid-view"
                class="d-flex align-items-center justify-content-center"
              >
                <svg
                  width="28"
                  height="25"
                  viewBox="-19 -19 600 600"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="m251.25 12.5c0-6.90625-5.59375-12.5-12.5-12.5h-226.25c-6.90625 0-12.5 5.59375-12.5 12.5v226.25c0 6.90625 5.59375 12.5 12.5 12.5h226.25c6.90625 0 12.5-5.59375 12.5-12.5zm-25 213.75h-201.25v-201.25h201.25zm0 0"
                  />
                  <path
                    d="m562.5 12.5c0-6.90625-5.59375-12.5-12.5-12.5h-226.25c-6.90625 0-12.5 5.59375-12.5 12.5v226.25c0 6.90625 5.59375 12.5 12.5 12.5h226.25c6.90625 0 12.5-5.59375 12.5-12.5zm-25 213.75h-201.25v-201.25h201.25zm0 0"
                  />
                  <path
                    d="m251.25 323.75c0-6.90625-5.59375-12.5-12.5-12.5h-226.25c-6.90625 0-12.5 5.59375-12.5 12.5v226.25c0 6.90625 5.59375 12.5 12.5 12.5h226.25c6.90625 0 12.5-5.59375 12.5-12.5zm-25 212.5h-201.25v-200h201.25zm0 0"
                  />
                  <path
                    d="m562.5 323.75c0-6.90625-5.59375-12.5-12.5-12.5h-226.25c-6.90625 0-12.5 5.59375-12.5 12.5v226.25c0 6.90625 5.59375 12.5 12.5 12.5h226.25c6.90625 0 12.5-5.59375 12.5-12.5zm-25 212.5h-201.25v-200h201.25zm0 0"
                  />
                </svg>
              </li>
              <li id="listing-view" class="active">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="19"
                  viewBox="0 0 22 19"
                >
                  <path
                    id="burger.svg"
                    fill="#000000"
                    d="M3436,60V57h22v3h-22Zm0-11h22v3h-22V49Zm0-8h22v3h-22V41Z"
                    transform="translate(-3436 -41)"
                  />
                </svg>
              </li>
            </ul>
          </div> -->
          <!----grid view end------->
        </div>
        <!----meeting tab end------>

        <div id="divnomeetings">
          <p class="text-center">
            {{ $t("mymeetings.nomeeting") }}
          </p>
        </div>

        <div class="sponsors-inner-hld attendee-list d-flex meeting-list">
          <!---tab content---->
          <div class="tab-content full-width">
            <!----Confirmed tab start--------->
            <div class="tab-pane active" id="Confirmed">
              <div class="row">
                <!----toogle button----->
                <div class="col-md-12" style="display: none">
                  <div class="custom-control custom-switch text-right">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="customSwitch1"
                      checked
                      v-on:click="toggleShowAll()"
                    />
                    <label class="custom-control-label" for="customSwitch1">{{
                      $t("mymeetings.showall")
                    }}</label>
                  </div>
                </div>
                <!--------->

                <!---attendee-box start-------->
                <div class="col-md-12" v-if="confirmCount == 0">
                  <div class="no-meeting-text">
                    <p class="no-meeting-paragraph">
                      Start By Requesting For a
                      <span v-on:click="navigate" class="cursor-pointer">
                        New Meeting
                        <img src="../assets/Images/right-arrow-black.svg"
                      /></span>
                    </p>
                  </div>
                </div>

                <div
                  class="col-md-6 col-lg-4 meeting-box-hld listing-view-box mb-3"
                  v-for="(attendee, index) in attendeeData"
                  :key="attendee.id"
                  v-show="
                    (attendee.ReceiverId == Userlists.userId ||
                      attendee.SenderId == Userlists.userId) &&
                    attendee.Status == 'Accepted'
                  "
                >
                  <div
                    v-bind:class="[
                      attendee.MeetingCurrentStatus === 'Meeting Ended'
                        ? 'dvtoShow'
                        : 'dvtoShow',
                    ]"
                  >
                    <div
                      v-if="
                        (attendee.ReceiverId == Userlists.userId ||
                          attendee.SenderId == Userlists.userId) &&
                        attendee.Status == 'Accepted'
                      "
                      class="sponsors-box-hld py-md-3"
                    >
                      <div
                        v-if="attendee.ReceiverId == Userlists.userId"
                        class="d-flex align-items-center top-img-box full-width cd"
                        data-toggle="modal"
                        v-bind:data-target="'#Attendee' + index"
                        data-tag="MeetingsAttendeeDetailsPopup"
                      >
                        <!-- <span class="attendee-img-area">
                        <img
                          v-bind:src="attendee.Organizerprofilepic"
                          v-bind:alt="attendee.OrganizerFname"
                        />
                        </span>-->

                        <span
                          v-if="
                            attendee.Organizerprofilepic !== undefined &&
                            attendee.Organizerprofilepic.length > 0
                          "
                          class="attendee-img-area"
                        >
                          <img
                            v-bind:src="attendee.Organizerprofilepic"
                            v-bind:alt="attendee.OrganizerFname"
                          />
                        </span>
                        <span v-else class="attendee-img-area">{{
                          attendee.OrganizerAttendeesInitials
                        }}</span>

                        <div class="grey-bg-texthld meeting-name">
                          <h3>{{ attendee.Organizername }}</h3>
                          <h4 v-html="attendee.OrganizerTitle"></h4>
                          <p v-html="attendee.OrganizerCompany"></p>
                        </div>
                        <!-- Add to Calendar desktop start -->
                        <div class="calender-icon-hld d-mob-none">
                          <p class="m-0 pl-md-15 pl-0">Add to Calendar</p>
                          <ul class="d-flex align-items-center">
                            <li>
                              <a
                                v-bind:href="AddToGoogleCalendar(attendee, 1)"
                                target="_blank"
                              >
                                <span>
                                  <img
                                    src="../assets/Images/icons/google-icon.svg"
                                    alt="google-icon"
                                  />
                                </span>
                              </a>
                            </li>
                            <li>
                              <a
                                v-bind:href="AddToOutlookCalendar(attendee, 1)"
                                target="_blank"
                              >
                                <span>
                                  <img
                                    src="../assets/Images/icons/outlook.svg"
                                    alt="outlook-icon"
                                  />
                                </span>
                              </a>
                            </li>
                          </ul>
                        </div>
                        <!-- Add to Calendar desktop end -->
                      </div>

                      <div
                        v-if="attendee.SenderId == Userlists.userId"
                        class="d-flex align-items-center top-img-box full-width"
                        data-toggle="modal"
                        v-bind:data-target="'#Attendee' + index"
                        data-tag="MeetingsAttendeeDetailsPopup"
                      >
                        <!-- <span class="attendee-img-area">
                        <img v-bind:src="attendee.Image" v-bind:alt="attendee.Name" />
                        </span>-->

                        <span
                          v-if="
                            attendee.Image !== undefined &&
                            attendee.Image.length > 0
                          "
                          class="attendee-img-area"
                        >
                          <img
                            v-bind:src="attendee.Image"
                            v-bind:alt="attendee.Name"
                          />
                        </span>
                        <span v-else class="attendee-img-area">{{
                          attendee.AttendeeInitials
                        }}</span>

                        <div class="grey-bg-texthld meeting-name">
                          <h3>{{ attendee.Name }}</h3>
                          <h4 v-html="attendee.Title"></h4>
                          <p v-html="attendee.Company"></p>
                        </div>
                        <!-----26.08.2020 add to calender------>
                        <div class="calender-icon-hld d-mob-none">
                          <p class="m-0 pl-md-15 pl-0">Add to Calendar</p>
                          <ul class="d-flex align-items-center">
                            <li>
                              <a
                                v-bind:href="AddToGoogleCalendar(attendee, 2)"
                                target="_blank"
                              >
                                <span>
                                  <img
                                    src="../assets/Images/icons/google-icon.svg"
                                    alt="google-icon"
                                  />
                                </span>
                              </a>
                            </li>
                            <li>
                              <a
                                v-bind:href="AddToOutlookCalendar(attendee, 2)"
                                target="_blank"
                              >
                                <span>
                                  <img
                                    src="../assets/Images/icons/outlook.svg"
                                    alt="outlook-icon"
                                  />
                                </span>
                              </a>
                            </li>
                          </ul>
                        </div>
                        <!----------->
                      </div>

                      <div class="status redsn-evnts-col meeting-status">
                        <div class="session-status pt-0 d-none d-md-block">
                          <p>
                            <span
                              class="finish-session"
                              :style="
                                attendee.MeetingCurrentStatus === 'Live'
                                  ? 'background-color:#00a982;'
                                  : attendee.MeetingCurrentStatus === 'Upcoming'
                                  ? 'background-color:#FFC300;'
                                  : ''
                              "
                            ></span>
                            {{ attendee.MeetingCurrentStatus }}
                          </p>
                        </div>
                        <article>
                          <ul class="p-0">
                            <li>
                              <h5 class="ico-calender-sm">
                                {{ attendee.StartDate }}
                              </h5>
                            </li>
                            <li>
                              <p class="ico-pin-sm">{{ attendee.StartTime }}</p>
                            </li>
                          </ul>
                        </article>
                        <!-- mobile session-status start -->
                        <div class="session-status pt-0 d-block d-md-none my-1">
                          <p>
                            <span
                              class="finish-session"
                              :style="
                                attendee.MeetingCurrentStatus === 'Live'
                                  ? 'background-color:#00a982;'
                                  : attendee.MeetingCurrentStatus === 'Upcoming'
                                  ? 'background-color:#FFC300;'
                                  : ''
                              "
                            ></span>
                            {{ attendee.MeetingCurrentStatus }}
                          </p>
                        </div>
                        <!-- mobile session-status en -->
                        <!-- mobile Add to Calendar start -->
                        <div class="calender-icon-hld d-md-none d-flex">
                          <ul class="d-flex align-items-center">
                            <li>
                              <a
                                v-bind:href="AddToGoogleCalendar(attendee, 1)"
                                target="_blank"
                              >
                                <span>
                                  <img
                                    src="../assets/Images/icons/google-icon.svg"
                                    alt="google-icon"
                                  />
                                </span>
                              </a>
                            </li>
                            <li>
                              <a
                                v-bind:href="AddToOutlookCalendar(attendee, 1)"
                                target="_blank"
                              >
                                <span>
                                  <img
                                    src="../assets/Images/icons/outlook.svg"
                                    alt="outlook-icon"
                                  />
                                </span>
                              </a>
                            </li>
                          </ul>
                        </div>
                        <!--mobile Add to Calendar  end -->
                        <div
                          class="button-area text-right d-flex justify-content-between align-item-center"
                        >
                          <v-btn
                            :disabled="
                              attendee.MeetingCurrentStatus == 'Meeting Ended'
                            "
                            v-if="attendee.Status != 'Cancelled'"
                            depressed
                            :loading="attendee.cancelInProcess"
                            class="btn-rounded mr-2 cancle-circle"
                            style="box-shadow: none !important"
                            v-on:click="
                              cancelMeeting(attendee.MeetingId, $event)
                            "
                            data-tag="MeetingCancelled"
                          >
                            {{ $t("mymeetings.cancel") }}
                          </v-btn>
                          <v-btn
                            :disabled="
                              attendee.MeetingCurrentStatus == 'Meeting Ended'
                            "
                            v-if="attendee.Status == 'Pending'"
                            depressed
                            :loading="attendee.acceptInProcess"
                            class="btn-rounded accept-btn"
                            v-on:click="
                              acceptMeeting(attendee.MeetingId, $event)
                            "
                            data-tag="MeetingConfirmed"
                          >
                            {{ $t("mymeetings.accept") }}
                          </v-btn>

                          <button
                            :disabled="attendee.MeetingCurrentStatus !== 'Live'"
                            v-if="attendee.Status == 'Accepted'"
                            v-on:click="
                              StartBroadcast(
                                attendee.MeetingId,
                                attendee.StreamingClient
                              );
                              return false;
                            "
                            :style="
                              attendee.MeetingCurrentStatus !== 'Live'
                                ? 'background-color:#eee; color:#000;'
                                : ''
                            "
                            :class="
                              attendee.MeetingCurrentStatus === 'Live'
                                ? 'btn-rounded j-meeting-btn'
                                : attendee.MeetingCurrentStatus === 'Upcoming'
                                ? 'btn-rounded disable-slot j-meeting-btn'
                                : 'btn-rounded disable-slot j-meeting-btn'
                            "
                            data-tag="joinMeeting"
                          >
                            {{ $t("mymeetings.joinmeeting") }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--attendee-box end----->
              </div>
            </div>
            <!----Confirmed tab end--------->

            <!----Request Sent tab start--------->
            <div class="tab-pane" id="RequestSent">
              <div class="row">
                <!---attendee-box start-------->
                <div class="col-md-12" v-if="requestSentCount == 0">
                  <div class="no-meeting-text">
                    <p class="no-meeting-paragraph">
                      Start By Requesting For a
                      <span v-on:click="navigate" class="cursor-pointer">
                        New Meeting
                        <img src="../assets/Images/right-arrow-black.svg"
                      /></span>
                    </p>
                  </div>
                </div>
                <div
                  class="col-md-6 col-lg-4 meeting-box-hld listing-view-box mb-3 my-meeting-box-hld meeting-wraparea"
                  v-for="(attendee, index) in attendeeData"
                  :key="attendee.id"
                  v-show="attendee.SenderId == Userlists.userId"
                >
                  <div
                    v-if="attendee.SenderId == Userlists.userId"
                    class="sponsors-box-hld my-meetings-hld"
                  >
                    <div
                      class="d-flex align-items-center top-img-box full-width"
                      data-toggle="modal"
                      v-bind:data-target="'#Attendee' + index"
                    >
                      <!-- <span class="attendee-img-area">
                        <img v-bind:src="attendee.Image" v-bind:alt="attendee.Name" />
                      </span>-->

                      <span
                        v-if="
                          attendee.Image !== undefined &&
                          attendee.Image.length > 0
                        "
                        class="attendee-img-area"
                      >
                        <img
                          v-bind:src="attendee.Image"
                          v-bind:alt="attendee.Name"
                        />
                      </span>
                      <span v-else class="attendee-img-area">{{
                        attendee.AttendeeInitials
                      }}</span>
                      <!-- <span
                          v-if="attendee.Organizerprofilepic!== undefined && attendee.Organizerprofilepic.length>0"
                          class="attendee-img-area"
                        >
                          <img
                            v-bind:src="attendee.Organizerprofilepic"
                            v-bind:alt="attendee.OrganizerFname"
                          />
                        </span> -->

                      <div class="grey-bg-texthld meeting-name">
                        <h3>{{ attendee.Name }}</h3>
                        <h4 v-html="attendee.Title"></h4>
                        <p v-html="attendee.Company"></p>
                      </div>
                    </div>
                    <div class="status redsn-evnts-col meeting-status">
                      <article>
                        <ul class="p-0">
                          <li class="d-mob-none">
                            <span
                              v-if="attendee.Status == 'Pending'"
                              class="pending"
                              >{{ attendee.Status }}</span
                            >
                            <span
                              v-else-if="attendee.Status == 'Accepted'"
                              class="accepted"
                              >{{ attendee.Status }}</span
                            >
                            <span v-else class="Cancelled">{{
                              attendee.Status
                            }}</span>
                          </li>
                          <li>
                            <h5 class="ico-calender-sm">
                              {{ attendee.StartDate }}
                            </h5>
                          </li>
                          <li>
                            <p class="ico-pin-sm">{{ attendee.StartTime }}</p>
                          </li>
                        </ul>
                        <!---mobile status start-->
                        <div class="d-block d-md-none my-1">
                          <span
                            v-if="attendee.Status == 'Pending'"
                            class="pending"
                            >{{ attendee.Status }}</span
                          >
                          <span
                            v-else-if="attendee.Status == 'Accepted'"
                            class="accepted"
                            >{{ attendee.Status }}</span
                          >
                          <span v-else class="Cancelled">{{
                            attendee.Status
                          }}</span>
                        </div>
                        <!---mobile status end-->
                      </article>
                      <div class="button-area text-right">
                        <v-btn
                          :disabled="
                            attendee.MeetingCurrentStatus == 'Meeting Ended'
                          "
                          v-if="attendee.Status != 'Cancelled'"
                          depressed
                          :loading="attendee.cancelInProcess"
                          class="btn-rounded mr-md-2 cancle-circle"
                          v-on:click="cancelMeeting(attendee.MeetingId, $event)"
                          data-tag="MeetingCancelled"
                        >
                          {{ $t("mymeetings.cancel") }}
                        </v-btn>
                        <button
                          :disabled="attendee.MeetingCurrentStatus !== 'Live'"
                          v-if="attendee.Status == 'Accepted'"
                          v-on:click="
                            StartBroadcast(
                              attendee.MeetingId,
                              attendee.StreamingClient
                            );
                            return false;
                          "
                          :style="
                            attendee.MeetingCurrentStatus !== 'Live'
                              ? 'background-color:#eee; color:#000;'
                              : ''
                          "
                          :class="
                            attendee.MeetingCurrentStatus === 'Live'
                              ? 'btn-rounded j-meeting-btn'
                              : attendee.MeetingCurrentStatus === 'Upcoming'
                              ? 'btn-rounded disable-slot j-meeting-btn'
                              : 'btn-rounded disable-slot j-meeting-btn ml-2'
                          "
                          data-tag="joinMeeting"
                        >
                          {{ $t("mymeetings.joinmeeting") }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <!--attendee-box end----->
              </div>
              <!----Pending tab end-------->
            </div>
            <!----tab end------------>
            <!----Request Recieved tab start--------->
            <div class="tab-pane" id="RequestReceived">
              <div class="row">
                <!---attendee-box start-------->
                <div class="col-md-12" v-if="requestReceivedCount == 0">
                  <div class="no-meeting-text">
                    <p class="no-meeting-paragraph">
                      Start By Requesting For a
                      <span v-on:click="navigate" class="cursor-pointer">
                        New Meeting
                        <img src="../assets/Images/right-arrow-black.svg"
                      /></span>
                    </p>
                  </div>
                </div>
                <div
                  class="col-md-6 col-lg-4 meeting-box-hld listing-view-box mb-3 my-meeting-box-hld meeting-wraparea"
                  v-for="(attendee, index) in attendeeData"
                  :key="attendee.id"
                  v-show="attendee.ReceiverId == Userlists.userId"
                >
                  <div
                    v-if="attendee.ReceiverId == Userlists.userId"
                    class="sponsors-box-hld my-meetings-hld"
                  >
                    <div
                      class="d-flex align-items-center top-img-box full-width"
                      data-toggle="modal"
                      v-bind:data-target="'#Attendee' + index"
                    >
                      <!-- <span class="attendee-img-area">
                        <img
                          v-bind:src="attendee.Organizerprofilepic"
                          v-bind:alt="attendee.OrganizerFname"
                        />
                      </span>-->

                      <span
                        v-if="
                          attendee.Organizerprofilepic !== undefined &&
                          attendee.Organizerprofilepic.length > 0
                        "
                        class="attendee-img-area"
                      >
                        <img
                          v-bind:src="attendee.Organizerprofilepic"
                          v-bind:alt="attendee.OrganizerFname"
                        />
                      </span>
                      <span v-else class="attendee-img-area">{{
                        attendee.OrganizerAttendeesInitials
                      }}</span>
                      <!-- <span
                          v-if="attendee.Organizerprofilepic!== undefined && attendee.Organizerprofilepic.length>0"
                          class="attendee-img-area"
                        >
                          <img
                            v-bind:src="attendee.Organizerprofilepic"
                            v-bind:alt="attendee.OrganizerFname"
                          />
                        </span> -->

                      <div class="grey-bg-texthld meeting-name">
                        <h3>{{ attendee.Organizername }}</h3>
                        <h4 v-html="attendee.OrganizerTitle"></h4>
                        <p v-html="attendee.OrganizerCompany"></p>
                      </div>
                    </div>
                    <div class="status redsn-evnts-col meeting-status">
                      <article>
                        <ul class="p-0">
                          <li class="d-mob-none">
                            <span
                              v-if="attendee.Status == 'Pending'"
                              class="pending"
                              >{{ attendee.Status }}</span
                            >
                            <span
                              v-else-if="attendee.Status == 'Accepted'"
                              class="accepted"
                              >{{ attendee.Status }}</span
                            >
                            <span v-else class="Cancelled">{{
                              attendee.Status
                            }}</span>
                          </li>
                          <li>
                            <h5 class="ico-calender-sm">
                              {{ attendee.StartDate }}
                            </h5>
                          </li>
                          <li>
                            <p class="ico-pin-sm">{{ attendee.StartTime }}</p>
                          </li>
                        </ul>
                        <!-- mobile status start-->
                        <div class="d-block d-md-none my-1">
                          <span
                            v-if="attendee.Status == 'Pending'"
                            class="pending"
                            >{{ attendee.Status }}</span
                          >
                          <span
                            v-else-if="attendee.Status == 'Accepted'"
                            class="accepted"
                            >{{ attendee.Status }}</span
                          >
                          <span v-else class="Cancelled">{{
                            attendee.Status
                          }}</span>
                        </div>
                        <!-- mobile status end-->
                      </article>
                      <div class="button-area text-right">
                        <v-btn
                          :disabled="
                            attendee.MeetingCurrentStatus == 'Meeting Ended'
                          "
                          v-if="attendee.Status != 'Rejected'"
                          depressed
                          :loading="attendee.rejectInProcess"
                          class="btn-rounded mr-2 cancle-circle"
                          v-on:click="rejectMeeting(attendee.MeetingId, $event)"
                          data-tag="MeetingRejected"
                        >
                          {{ $t("mymeetings.reject") }}
                        </v-btn>
                        <v-btn
                          :disabled="
                            attendee.MeetingCurrentStatus == 'Meeting Ended'
                          "
                          v-if="attendee.Status == 'Pending'"
                          depressed
                          :loading="attendee.acceptInProcess"
                          class="btn-rounded accept-btn"
                          v-on:click="acceptMeeting(attendee.MeetingId, $event)"
                          data-tag="MeetingConfirmed"
                        >
                          {{ $t("mymeetings.accept") }}
                        </v-btn>
                        <button
                          :disabled="attendee.MeetingCurrentStatus !== 'Live'"
                          :style="
                            attendee.MeetingCurrentStatus !== 'Live'
                              ? 'background-color:#eee; color:#000;'
                              : ''
                          "
                          :class="
                            attendee.MeetingCurrentStatus === 'Live'
                              ? 'btn-rounded j-meeting-btn'
                              : attendee.MeetingCurrentStatus === 'Upcoming'
                              ? 'btn-rounded disable-slot j-meeting-btn'
                              : 'btn-rounded disable-slot j-meeting-btn'
                          "
                          v-if="attendee.Status == 'Accepted'"
                          v-on:click="
                            StartBroadcast(
                              attendee.MeetingId,
                              attendee.StreamingClient
                            );
                            return false;
                          "
                          data-tag="Accepted"
                        >
                          {{ $t("mymeetings.joinmeeting") }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <!--attendee-box end----->
              </div>
            </div>
            <!----Request Recieved tab end--------->
          </div>
        </div>
      </div>

      <!-- <AttendeeDetails
        :id="'Attendee' + index"
        v-for="(attendee, index) in attendeeData"
        v-bind:key="attendee.meetingId"
        v-bind:Image="attendee.Image"
        v-bind:attendeeName="attendee.Name"
        v-bind:Title="attendee.Title"
        v-bind:Company="attendee.Company"
        v-bind:Profile="attendee.Profile"
        v-bind:Email="attendee.Email"
        v-bind:Phone="attendee.Phone"
        v-bind:AttendeeInitials="getInitials(attendee.Name)"
        v-bind:OrganizerAttendeesInitials="getInitials(attendee.Name)"
        v-bind:MeetingCurrentStatus="getMeetingCurrentStatus(attendee.StartDateTime,attendee.EndDateTime)"
      ></AttendeeDetails>-->
      <!-- 
      <RequestMeeting
        :id="'Rescheduled' + index"
        v-for="(attendee, index) in attendeeData"
        v-bind:key="attendee.meetingId"
        v-bind:MeetingId="attendee.MeetingId"
        v-bind:MeetingType="'Attendee'"
        v-bind:attendeeId="attendee.attendeeId"
        v-bind:attendeeName="attendee.Name"
        v-bind:Image="attendee.Image"
        v-bind:Company="attendee.Company"
        v-bind:Title="attendee.Title"
        v-bind:Email="attendee.Email"
        v-bind:Phone="attendee.Phone"
      ></RequestMeeting>-->
      <div
        id="RetryJoinInZoom"
        class="modal fade"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog" role="document" style="max-width: 400px">
          <div class="modal-content">
            <div class="modal-body">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18.03"
                  height="18.031"
                  viewBox="0 0 18.03 18.031"
                >
                  <path
                    id="close.svg"
                    fill="#242432"
                    d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                    transform="translate(-1412 -516)"
                  />
                </svg>
              </button>

              <div class="retry-modal p-4">
                <p style="font-size: 20px; font-weight: 600; color: #1e1f26">
                  Please try again.
                </p>
                <div>
                  <a
                    href="javascript:void(0)"
                    class="button-no"
                    @click="cancelRetryJoinInZoom"
                    >Cancel</a
                  >
                  <a
                    href="javascript:void(0)"
                    class="button-yes"
                    @click="retryJoinInZoom"
                    >Retry</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// import moment from "moment";
import moment from "moment-timezone";
import db from "../components/firebaseInit";
import router from "../router";
//import TopMenu from "@/components/TopMenu.vue";
//import RequestMeeting from "@/components/RequestMeeting.vue";
//import AttendeeDetails from "@/components/AttendeeDetails.vue";
import axios from "axios";
import APIs from "@/components/APIInit";
import analytics from "@/components/Analytics";
import common from "@/common";
import { bus } from "@/main";
import jQuery from "jquery";
let $ = jQuery;
let obj = JSON.parse(window.localStorage.getItem("my-app"));
let self;
//let lastVisible = null;
//let hasMore = true;

let interval;

export default {
  data() {
    return {
      confirmCount: 0,
      requestSentCount: 0,
      requestReceivedCount: 0,
      headerText: this.$t("mymeetings.mymeetings"),
      pageSize: 9,
      pageIndex: 0,
      totalRecords: 1,
      lastVisible: null,
      attendeeData: [],
      LiveStageURL: "/livestage",

      GlobalKeysData: {
        IsOpenInternalPlayer: 1,
        IsBroadcastInNewTab: 1,
        broadcastbaseURL:
          "https://he96zdju46.execute-api.us-east-1.amazonaws.com/PRD/",
        BroadcastID: "605f401455444442838e00cb859c037b",
        BroadcastCertificate: "8f472eef21f64cba97c105eab797522f",
        BroadcastSpeakerApiUrl:
          "https://onairapi.e2m.live/get-session-token-speaker",
        BroadcastAttendeeApiUrl:
          "https://onairapi.e2m.live/get-session-token-attendee",
        BroadcastStartURL: "https://onair2.e2m.live/video/live-broadcast.html",
        BroadcastViewURL: "https://onair2.e2m.live/video/live-audience.html",
        videoId: "605f401455444442838e00cb859c037b",
        BroadcastvalidityHours: "72",
        ChannelPrefix: "OAUAT",
        OnDemandTypeID: 1,
        LiveStreamTypeID: 2,
        LivePanelTypeID: 3,
        RoundTableTypeID: 4,
        videoParamsEncryptURL: "https://awsapi.e2m.live/encrypt-call-params",
        Showall: false,
      },
      EmailURL: "https://awsapi.e2m.live/send-email",

      FCMURL: "https://fcm.googleapis.com/fcm/send",
      APIs: APIs,
      zoomErrorMsg:
        "An error has occurred with this Zoom live panel session. Please try again in sometime.",
      uid: "",
      email: "",
      firstName: "",
      lastName: "",
      name: "",
      localTimeZone: "",
      RestrictedZoomMeetingEnabled: true,
      tempMeeting: null,
      bookMeetingURL: "/Attendee",
      event_collectionName: "",
      clientId: "",
      eventId: "",
    };
  },
  components: {
    //TopMenu,
    // AttendeeDetails,
  },
  computed: {
    Userlists() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      return {
        userId: obj.user[0].id,
        userName: obj.user[0].name,
        userImage: obj.user[0].profilepic,
        userEmail: obj.user[0].Email,
        userPhone: obj.user[0].phone,
        userTitle: obj.user[0].title,
        userCompmany: obj.user[0].company,
      };
    },
  },
  created() {
    self = this;
    self.event_collectionName = self.getEventCollectionName();
    self.clientId = self.getClientId();
    self.eventId = self.getEventId();
    var obj = JSON.parse(window.localStorage.getItem("my-app"));
    if (obj && obj.user && obj.user.length > 0) {
      self.uid = obj.user[0].id;
      self.email = obj.user[0].Email;
      self.firstName = obj.user[0].fname;
      self.lastName = obj.user[0].lname;
      self.name = obj.user[0].name;
    }
    self.localTimeZone = common.getTimeZoneName();
    self.getMeetingSettings();
    debugger;
    let tab = self.$route.hash;
    if (tab) {
      //$("#RequestReceived").tab('show')
      $('.nav-tabs a[href="#RequestReceived"]').click();
    }
    // Confirmed
    // RequestSent
    // RequestReceived
  },
  methods: {
    getMeetingSettings() {
      let headers = {
        Authorization: "Bearer " + self.getSessionToken(),
        "content-type": "application/json",
      };
      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: self.clientId,
          eventId: self.eventId,
        },
      };
      axios
        .post(
          self.APIs.MeetingAPIConfig.GetConfig,
          JSON.stringify(requestData),
          {
            headers: headers,
          }
        )
        .then((response) => {
          if (response && response.data && response.data.data) {
            self.bookMeetingURL = response.data.data.BookMeetingURL;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    GetTimeByZone: function (strDateTime, timeZone) {
      strDateTime = moment(strDateTime).format();
      var strtDate = moment.tz(strDateTime, timeZone);
      strtDate._d.setMinutes(strtDate._d.getMinutes() - strtDate._offset);
      return strtDate._d;
    },
    toggleShowAll: function () {
      if ($("#customSwitch1").is(":checked")) {
        // self.attendeeData = self.attendeeData.filter(e => e.MeetingCurrentStatus !="Meeting Ended");
        $(".dvEnded").show();
      } else {
        //  return false;
        $(".dvEnded").hide();
      }
      //
    },
    navigate() {
      if (
        !self.bookMeetingURL ||
        self.bookMeetingURL.toLowerCase() == "/attendee"
      ) {
        router.push({
          name: "AttendeeList",
          query: { filter: true, search: true },
        });
      } else {
        router.push(self.bookMeetingURL);
      }
    },

    getCalendarDateTime: function (s, option) {
      var dt = new Date(s * 1000);

      var day = dt.getDate();
      var month = dt.getMonth() + 1;
      var year = dt.getFullYear();
      if (month < 10) {
        month = "0" + month.toString();
      }
      if (day < 10) {
        day = "0" + day.toString();
      }
      var hours = dt.getHours();
      if (hours < 10) {
        hours = "0" + hours.toString();
      }
      var minutes = dt.getMinutes();
      if (minutes < 10) {
        minutes = "0" + minutes.toString();
      }
      var seconds = dt.getSeconds();
      if (seconds < 10) {
        seconds = "0" + seconds.toString();
      }

      var formattedValue = "";
      if (option == "google") {
        formattedValue =
          year.toString() +
          month.toString() +
          day.toString() +
          "T" +
          hours.toString() +
          minutes.toString() +
          seconds.toString();
      } else if (option == "outlook") {
        formattedValue =
          year.toString() +
          "%2F" +
          month.toString() +
          "%2F" +
          day.toString() +
          "+";

        if (hours < 10) {
          formattedValue += hours.toString() + "%3A";
        } else {
          if (hours <= 12) {
            formattedValue += hours.toString() + "%3A";
          } else {
            formattedValue += (hours - 12).toString() + "%3A";
          }
        }

        if (minutes < 10) {
          formattedValue += minutes.toString() + "+";
        } else {
          formattedValue += minutes.toString() + "+";
        }

        if (hours < 12) {
          formattedValue += "AM";
        } else {
          formattedValue += "PM";
        }
      }
      return formattedValue;
    },

    BookMeetingSlots(MeetingDateTime, OrganizerId) {
      //

      // var availableSlot = [];
      var dtStartDateTime = new Date(MeetingDateTime.seconds * 1000);
      var dtCurrent = moment(dtStartDateTime).format("MMMDD");
      var dttime = moment(dtStartDateTime).format("hh:mm A");
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      var AvailableMeetingSlots = "AvailableMeetingSlots";
      var attendeeId = obj.user[0].id;

      var MdocRef = db
        .collection(obj.eventcollectionname)
        .doc("AttendeeList")
        .collection("Attendees")
        .doc(attendeeId)
        .collection(AvailableMeetingSlots)
        .where("StartDate", "==", moment(dtCurrent, moment.tz.guess()))
        .where("StartDatetime", "==", moment(dttime, moment.tz.guess()));

      MdocRef.get().then((querySnapshot) => {
        querySnapshot.forEach(function (doc) {
          doc.ref.delete();
        });
      });

      var OdocRef = db
        .collection(obj.eventcollectionname)
        .doc("AttendeeList")
        .collection("Attendees")
        .doc(OrganizerId)
        .collection(AvailableMeetingSlots)
        .where("StartDate", "==", dtCurrent)
        .where("StartDatetime", "==", dttime);

      OdocRef.get().then((querySnapshot) => {
        querySnapshot.forEach(function (doc) {
          doc.ref.delete();
        });
      });
    },
    getMeetingCurrentStatus: function (StartDateTime, EndDateTime) {
      var dtStartDateTime = StartDateTime;
      var dtEndDateTime = EndDateTime;

      var MeetingCurrentStatus = "";
      var dtcurrentDate = moment(new Date(), "UTC")
        .tz(moment.tz.guess())
        .format("YYYY-MM-DDTHH:mm:ss[Z]");

      if (dtStartDateTime > dtcurrentDate) {
        MeetingCurrentStatus = "Upcoming";
      }
      if (dtStartDateTime < dtcurrentDate && dtEndDateTime < dtcurrentDate) {
        MeetingCurrentStatus = "Meeting Ended";
      }
      if (dtStartDateTime < dtcurrentDate && dtEndDateTime >= dtcurrentDate) {
        MeetingCurrentStatus = "Live";
      }
      return MeetingCurrentStatus;
    },

    MeetingUpdate: function (
      MeetingId,
      Name, // AttendeeName
      Email, //AttendeeEmail
      Title, //AttendeeTitle
      Company, //AttendeeCompany
      Organizername,
      OrganizerEmail,
      OrganizerTitle,
      OrganizerCompany,
      Message,
      StartDateTime, //MeetingStartDateTime
      MeetingStatus, //Status-Request Sent, Request Received, Accepted
      attendeeId,
      attendeeImage,
      OrganizerId,
      OrganizerImage
    ) {
      var docRef = db
        .collection(obj.eventcollectionname)
        .doc("MeetingList")
        .collection("Meetings")
        .doc(MeetingId);
      docRef
        .get()
        .then(function (doc) {
          if (doc.exists) {
            StartDateTime = moment(doc.data().StartDateTime, "hh:mm A");
            self.TimezoneUpdate(MeetingId);
            db.collection(obj.eventcollectionname)
              .doc("MeetingList")
              .collection("Meetings")
              .doc(MeetingId)
              .update({
                Status: MeetingStatus,
                LastModifiedDate: new Date(),
              })
              .then(function () {
                //
                if (MeetingStatus === "Accepted") {
                  //
                  //self.BookMeetingSlots(StartDateTime, OrganizerId);

                  //alert("You have accepted this meeting");

                  var objEventName;
                  if (obj.eventname !== undefined) {
                    objEventName = obj.eventname;
                  } else {
                    objEventName = "";
                  }

                  //StartDateTime = moment(doc.data().StartDateTime, "hh:mm A");

                  //**** Start EMAIL Acceptance Mail To Meeting Receiver

                  var htmlmailbody3 = self.AcceptedMeetingEmailHtml(
                    Organizername,
                    Name,
                    OrganizerEmail,
                    OrganizerTitle,
                    OrganizerCompany,
                    StartDateTime,
                    Message
                  );

                  var ToEmail = Email;
                  if (location.origin.toLowerCase().indexOf("localhost") >= 0) {
                    ToEmail = "vishalakshi.murthy@webspiders.com";
                  }

                  var requestData3 = {
                    from: objEventName + "<noreply@mail.e2m.live>",
                    to: {
                      name: Name,
                      email: ToEmail,
                    },
                    // subject: Organizername + " have accepted this meeting",
                    subject: "You have accepted this meeting",
                    html: htmlmailbody3,
                  };
                  self.SentMeetingMail(requestData3);

                  //**** End EMAIL Acceptance Mail To Meeting Receiver

                  //**** Start EMAIL Acceptance Mail To Meeting Sender

                  var htmlmailbody4 = self.AcceptedMeetingEmailHtml(
                    Name,
                    Organizername,
                    Email,
                    Title,
                    Company,
                    StartDateTime,
                    Message
                  );

                  ToEmail = OrganizerEmail;
                  if (location.origin.toLowerCase().indexOf("localhost") >= 0) {
                    ToEmail = "vishalakshi.murthy@webspiders.com";
                  }

                  var requestData4 = {
                    from: objEventName + "<noreply@mail.e2m.live>",
                    to: {
                      name: Organizername,
                      email: ToEmail,
                    },
                    subject: Name + " has accepted this meeting",
                    html: htmlmailbody4,
                  };

                  self.SentMeetingMail(requestData4);

                  console.log(OrganizerImage);

                  self.SentMeetingNotification(
                    "accepted",
                    obj.user[0].name,
                    attendeeImage != "" ? attendeeImage : "",
                    OrganizerId
                  );

                  //router.push({name:"MyMeetings"});
                  //self.displayAttendees();

                  //**** End EMAIL Acceptance Mail To Meeting Sender
                }

                // $(".modal-dialog.xl").addClass("success");
              })
              .catch(function (error) {
                console.error("Error updating Meeting: ", error);
              });
          }
        })
        .catch(function (error) {
          console.log("Error saving Meeting:", error);
        });
      //this.displayAttendees();
      self.getMeetingList();
    },
    setFirebaseAppsettings: function () {
      //
      var docRefGeneralSettings = db
        .collection("OA_UAT")
        .doc("GeneralSettings");
      docRefGeneralSettings.get().then(function (doc) {
        if (doc.exists) {
          self.EmailURL = doc.data().EmailURL;
        }
      });

      //var obj = JSON.parse(window.localStorage.getItem("my-app"));

      var docRef = db.collection("OA_UAT").doc("OnAirAppSettings");

      docRef.get().then(function (doc) {
        if (doc.exists) {
          self.GlobalKeysData.BroadcastID = doc.data().AppIDRTC;
          self.GlobalKeysData.BroadcastCertificate = doc.data().CertificateRTC;
          self.GlobalKeysData.BroadcastSpeakerApiUrl =
            doc.data().SpeakerTokenURL;
          self.GlobalKeysData.BroadcastAttendeeApiUrl =
            doc.data().AttendeeTokenURL;
          self.GlobalKeysData.BroadcastStartURL = doc.data().BroadcastBaseURL;
          self.GlobalKeysData.BroadcastViewURL = doc.data().AudienceBaseURL;
          self.GlobalKeysData.BroadcastvalidityHours =
            doc.data().TokenValidityHours;
          self.GlobalKeysData.ChannelPrefix = doc.data().ChannelPrefix;
          self.GlobalKeysData.videoParamsEncryptURL = doc.data().EncryptionURL;
        }
      });
    },
    MeetingCancelled: function (
      MeetingId,
      Name, // AttendeeName
      Email, //AttendeeEmail
      Title, //AttendeeTitle
      Company, //AttendeeCompanys
      Organizername,
      OrganizerEmail,
      OrganizerTitle,
      OrganizerCompany,
      Message,
      StartDateTime, //MeetingStartDateTime
      MeetingStatus, //Status-Request Sent, Request Received, Accepted
      attendeeId,
      attendeeImage,
      OrganizerId,
      OrganizerImage
    ) {
      if (confirm("Are you sure you want to cancel the meetinng")) {
        var docRef = db
          .collection(obj.eventcollectionname)
          .doc("MeetingList")
          .collection("Meetings")
          .doc(MeetingId);
        docRef
          .get()
          .then(function (doc) {
            if (doc.exists) {
              self.TimezoneUpdate(MeetingId);
              db.collection(obj.eventcollectionname)
                .doc("MeetingList")
                .collection("Meetings")
                .doc(MeetingId)
                .update({
                  Status: MeetingStatus,
                  LastModifiedDate: new Date(),
                })
                .then(function () {
                  //
                  var stTime = moment(
                    doc.data().StartDateTime,
                    "h:mm A"
                  ).format("hh:mm A");
                  var edTime = moment(doc.data().EndDateTime, "h:mm A").format(
                    "hh:mm A"
                  );

                  var AvailableMeetingSlotsId =
                    moment(StartDateTime).format("MMMDD") +
                    "_" +
                    stTime +
                    "_" +
                    edTime;
                  var MeetingTime = AvailableMeetingSlotsId.split("_");

                  var MdocRef1 = db
                    .collection(obj.eventcollectionname)
                    .doc("AttendeeList")
                    .collection("Attendees")
                    .doc(attendeeId)
                    .collection("AvailableMeetingSlots")
                    .doc(AvailableMeetingSlotsId);

                  MdocRef1.get()
                    .then(function (doc) {
                      if (!doc.exists) {
                        var docObj = new Object();
                        docObj.AvailableMeetingSlotsId =
                          AvailableMeetingSlotsId;
                        docObj.StartDate = MeetingTime[0];
                        docObj.StartDatetime = MeetingTime[1];
                        docObj.EndDateTime = MeetingTime[2];

                        MdocRef1.set(docObj)
                          .then(function () {
                            //console.log("AvailableMeetingSlots Created ");
                          })
                          .catch(function (error) {
                            console.error(
                              "Error AvailableMeetingSlots: ",
                              error
                            );
                          });
                      }
                    })
                    .catch(function (error) {
                      console.error(
                        "Error creating AvailableMeetingSlots: ",
                        error
                      );
                    });

                  var MdocRef2 = db
                    .collection(obj.eventcollectionname)
                    .doc("AttendeeList")
                    .collection("Attendees")
                    .doc(OrganizerId)
                    .collection("AvailableMeetingSlots")
                    .doc(AvailableMeetingSlotsId);

                  MdocRef2.get()
                    .then(function (doc) {
                      if (!doc.exists) {
                        var docObj = new Object();
                        docObj.AvailableMeetingSlotsId =
                          AvailableMeetingSlotsId;
                        docObj.StartDate = MeetingTime[0];
                        docObj.StartDatetime = MeetingTime[1];
                        docObj.EndDateTime = MeetingTime[2];

                        MdocRef2.set(docObj)
                          .then(function () {
                            //console.log("AvailableMeetingSlots Created ");
                          })
                          .catch(function (error) {
                            console.error(
                              "Error AvailableMeetingSlots: ",
                              error
                            );
                          });
                      }
                    })
                    .catch(function (error) {
                      console.error(
                        "Error creating AvailableMeetingSlots: ",
                        error
                      );
                    });

                  alert("The meeting has been cancelled.");

                  var objEventName;
                  if (obj.eventname !== undefined) {
                    objEventName = obj.eventname;
                  } else {
                    objEventName = "";
                  }

                  StartDateTime = moment(StartDateTime, "hh:mm A");

                  //**** Start cancelled Mail To Meeting Receiver
                  var htmlmailbody1 = self.CancelledMeetingEmailHtml(
                    Name,
                    Organizername,
                    Email,
                    Title,
                    Company,
                    StartDateTime,
                    Message
                  );

                  var ToEmail = OrganizerEmail;

                  if (location.origin.toLowerCase().indexOf("localhost") >= 0) {
                    ToEmail = "vishalakshi.murthy@webspiders.com";
                  }

                  var requestData1 = {
                    from: objEventName + "<noreply@mail.e2m.live>",
                    to: {
                      name: obj.eventname,
                      email: ToEmail,
                    },
                    subject: "Alert! Meeting Request Cancelled",
                    html: htmlmailbody1,
                  };

                  self.SentMeetingMail(requestData1);

                  //**** End cancelled Mail To Meeting Receiver

                  //**** Start accepted Mail To Meeting Sender

                  console.log(OrganizerImage);
                  var htmlmailbody2 = self.CancelledMeetingEmailHtml(
                    Organizername,
                    Name,
                    OrganizerEmail,
                    OrganizerTitle,
                    OrganizerCompany,
                    StartDateTime,
                    Message
                  );

                  ToEmail = Email;
                  if (location.origin.toLowerCase().indexOf("localhost") >= 0) {
                    ToEmail = "vishalakshi.murthy@webspiders.com";
                  }

                  var requestData2 = {
                    from: objEventName + "<noreply@mail.e2m.live>",
                    to: {
                      name: Name,
                      email: ToEmail,
                    },
                    // subject: Organizername + " has cancelled this meeting",
                    subject: "Alert! Meeting Request Cancelled",
                    html: htmlmailbody2,
                  };

                  self.SentMeetingMail(requestData2);

                  self.SentMeetingNotification(
                    "cancelled",
                    obj.user[0].name,
                    attendeeImage != "" ? attendeeImage : "",
                    OrganizerId
                  );
                  //self.displayAttendees();
                  self.getMeetingList();
                  //**** End accepted Mail To Meeting Sender
                })
                .catch(function (error) {
                  console.error("Error updating Meeting: ", error);
                });
            }
          })
          .catch(function (error) {
            console.log("Error saving Meeting:", error);
          });
        //this.displayAttendees();
      }
    },
    displayAttendees() {
      self.attendeeData = [];

      //
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      // var CurrentUserId = obj.user[0].id;
      self.pageIndex++;
      var listRef;

      listRef = db
        .collection(obj.eventcollectionname)
        .doc("MeetingList")
        .collection("Meetings");

      //
      listRef
        .orderBy("StartDateTime", "desc")
        .onSnapshot((querySnapshot) => {
          self.attendeeData = [];
          var ConfirmCtr = 0;
          var ReqSentCtr = 0;
          var ReqRecCtr = 0;
          $("#spConfirm").text("");
          $("#spReqSent").text("");
          $("#spReqRec").text("");
          if (querySnapshot.docs.length > 0) {
            //
            //  if (hasMore) {
            $("#divnomeetings").hide();
            //lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1];
            //
            querySnapshot.forEach((doc) => {
              var obj = JSON.parse(window.localStorage.getItem("my-app"));
              if (obj.MeetingSettings[0].ByTimezone === true) {
                self.attendeeData.push({
                  MeetingId: doc.id,
                  attendeeId: doc.data().AttendeeId,
                  MeetingType: doc.data().MeetingType,
                  Message: doc.data().Message,
                  Name: doc.data().AttendeeName,
                  Company: doc.data().Company,
                  Title: doc.data().Title,
                  StartDate: moment(
                    self.GetTimeByZone(
                      doc.data().StartDateTime.toDate(),
                      moment.tz.guess()
                    )
                  ).format("ddd D MMM"),
                  StartTime: moment(
                    self.GetTimeByZone(
                      doc.data().StartDateTime.toDate(),
                      moment.tz.guess()
                    )
                  ).format("hh:mm A"),
                  StartDateTime: moment(
                    self.GetTimeByZone(
                      doc.data().StartDateTime.toDate(),
                      moment.tz.guess()
                    )
                  ),
                  EndDateTime: moment(
                    self.GetTimeByZone(
                      doc.data().StartDateTime.toDate(),
                      moment.tz.guess()
                    )
                  ),
                  EndTime: moment(
                    self.GetTimeByZone(
                      doc.data().StartDateTime.toDate(),
                      moment.tz.guess()
                    )
                  ),
                  Email: doc.data().AttendeeEmail,
                  Image: doc.data().AttendeeImage,
                  Phone: doc.data().AttendeePone,
                  Status: doc.data().Status,
                  ReceiverId: doc.data().ReceiverId,
                  SenderId: doc.data().SenderId,

                  OrganizerId: doc.data().OrganizerAttendees.id,
                  OrganizerEmail: doc.data().OrganizerAttendees.Email,
                  OrganizerFname: doc.data().OrganizerAttendees.fname,
                  OrganizerLname: doc.data().OrganizerAttendees.lname,
                  Organizername: doc.data().OrganizerAttendees.name,
                  Organizerprofilepic: doc.data().OrganizerAttendees.profilepic,
                  OrganizerCompany: doc.data().OrganizerAttendees.company,
                  OrganizerTitle: doc.data().OrganizerAttendees.title,

                  AttendeeInitials: self.getInitials(
                    doc.data().FirstName + " " + doc.data().LastName
                  ),
                  OrganizerAttendeesInitials: self.getInitials(
                    doc.data().OrganizerAttendees.fname +
                      " " +
                      doc.data().OrganizerAttendees.lname
                  ),
                  MeetingCurrentStatus: self.getMeetingCurrentStatus(
                    doc.data().StartDateTime,
                    doc.data().EndDateTime
                  ),
                  ShowAll: $("#customSwitch1").is(":checked"),
                });
              } else {
                self.attendeeData.push({
                  MeetingId: doc.id,
                  attendeeId: doc.data().AttendeeId,
                  MeetingType: doc.data().MeetingType,
                  Message: doc.data().Message,
                  Name: doc.data().AttendeeName,
                  Company: doc.data().Company,
                  Title: doc.data().Title,
                  StartDate: moment(doc.data().StartDateTime.toDate()).format(
                    "ddd D MMM"
                  ),
                  StartTime: moment(doc.data().StartDateTime.toDate()).format(
                    "hh:mm A"
                  ),
                  StartDateTime: doc.data().StartDateTime,
                  EndDateTime: doc.data().EndDateTime,
                  EndTime: doc.data().EndDateTime,
                  Email: doc.data().AttendeeEmail,
                  Image: doc.data().AttendeeImage,
                  Phone: doc.data().AttendeePone,
                  Status: doc.data().Status,
                  ReceiverId: doc.data().ReceiverId,
                  SenderId: doc.data().SenderId,

                  OrganizerId: doc.data().OrganizerAttendees.id,
                  OrganizerEmail: doc.data().OrganizerAttendees.Email,
                  OrganizerFname: doc.data().OrganizerAttendees.fname,
                  OrganizerLname: doc.data().OrganizerAttendees.lname,
                  Organizername: doc.data().OrganizerAttendees.name,
                  Organizerprofilepic: doc.data().OrganizerAttendees.profilepic,
                  OrganizerCompany: doc.data().OrganizerAttendees.company,
                  OrganizerTitle: doc.data().OrganizerAttendees.title,

                  AttendeeInitials: doc.data().Initials,
                  OrganizerAttendeesInitials: self.getInitials(
                    doc.data().OrganizerAttendees.fname +
                      " " +
                      doc.data().OrganizerAttendees.lname
                  ),
                  MeetingCurrentStatus: self.getMeetingCurrentStatus(
                    doc.data().StartDateTime,
                    doc.data().EndDateTime
                  ),
                  ShowAll: $("#customSwitch1").is(":checked"),
                });
              }

              if (
                (doc.data().ReceiverId == obj.user[0].id ||
                  doc.data().SenderId == obj.user[0].id) &&
                doc.data().Status == "Accepted"
              ) {
                ConfirmCtr++;
              }
              if (doc.data().SenderId == obj.user[0].id) {
                ReqSentCtr++;
              }
              if (doc.data().ReceiverId == obj.user[0].id) {
                ReqRecCtr++;
              }
              $("#spConfirm").text("(" + ConfirmCtr + ")");
              $("#spReqSent").text("(" + ReqSentCtr + ")");
              $("#spReqRec").text("(" + ReqRecCtr + ")");
            });
          } else {
            $("#divnomeetings").show();
          }
        })
        .catch((error) => {
          console.log(error);
          // console.log("Error getting documents: ", error);
        });
    },
    attendeeLargeImg: function (img) {
      $("#imgModal").trigger("click");
      $("#attendeeImgSrc").attr("src", img);
    },
    getInitials: function (str) {
      var matches = str.match(/\b(\w)/g); // ['J','S','O','N']
      var acronym = matches.join(""); // JSON
      return acronym;
      //console.log(acronym);
    },
    scroll: function () {
      window.onscroll = () => {
        let bottomOfWindow =
          document.documentElement.scrollTop + window.innerHeight + 1 >=
          document.documentElement.offsetHeight;
        if (bottomOfWindow) {
          //self.displayAttendees();
          self.getMeetingList();
          //this.AddAnalitics(event, "scroll");
        }
      };
    },
    exitmenu: function () {
      //  $(".tab-content-one .tab-pane").removeClass("active");
      $(".nav-link.tab-link").removeClass("active");
    },
    StartBroadcast: function (meetingId, streamingClient) {
      if (!self.hasValidAuth({ auth_type: 1 })) {
        return;
      }
      self.tempMeeting = {
        meetingId: meetingId,
        streamingClient: streamingClient,
      };
      //var obj3 = JSON.parse(window.localStorage.getItem("my-app"));
      // if (
      //   screen.width < 767 &&
      //   obj3.AgoraPlayerBrowserSupportInMobile == false
      // ) {
      //   router.push("/screeninfo");
      // } else if (
      //   screen.width >= 768 &&
      //   screen.width <= 1024 &&
      //   obj3.AgoraPlayerBrowserSupportInIPad == false
      // ) {
      //   router.push("/screeninfo");
      // } else {
      if (streamingClient) {
        streamingClient = streamingClient.toLowerCase().trim();
      }
      if (!streamingClient || streamingClient == "web") {
        var channel = meetingId + "_o2o";
        router.push({
          path: self.LiveStageURL + "/" + channel,
        });
      } else if (streamingClient == "zoom") {
        var meetings = self.attendeeData.filter(function (item) {
          return item.MeetingId == meetingId;
        });
        var meeting;
        if (meetings.length > 0) {
          meeting = meetings[0];
        }
        if (
          meeting &&
          meeting.Host &&
          meeting.Host.length > 0 &&
          meeting.Zoom_Detail &&
          meeting.Zoom_Detail.id
        ) {
          if (self.uid == meeting.Host[0].AttendeeId) {
            var hlink =
              meeting.Zoom_Detail.start_url +
              "&uname=" +
              self.firstName.trim() +
              "%20" +
              self.lastName.trim();
            window.open(hlink, "_blank");
            self.postLeaderboardAction("O2OA");
          } else {
            if (!self.RestrictedZoomMeetingEnabled) {
              var link =
                meeting.Zoom_Detail.join_url +
                "&uname=" +
                self.firstName.trim() +
                "%20" +
                self.lastName.trim();
              window.open(link, "_blank");
              self.postLeaderboardAction("O2OA");
            } else {
              debugger;
              bus.$emit("toggleLoader", true);
              let headers = {
                Authorization: "Bearer " + self.getSessionToken(),
                "content-type": "application/json",
              };
              let requestData = {
                email: self.email,
                name: self.name,
                first_name: self.firstName,
                last_name: self.lastName,
                meetingid: meeting.Zoom_Detail.id,
                address: "",
                phone: self.phone,
                industry: "",
                org: self.company,
                job_title: self.title,
              };
              axios
                .post(APIs.AddAttendeesToZoom, requestData, {
                  headers: headers,
                })
                .then((response) => {
                  if (
                    response &&
                    response.data &&
                    response.data.status == 0 &&
                    response.data.data.id &&
                    response.data.data.join_url &&
                    response.data.data.join_url != ""
                  ) {
                    bus.$emit("toggleLoader", false);
                    window.open(response.data.data.join_url, "_blank");
                    self.postLeaderboardAction("SNVW");
                  } else {
                    bus.$emit("toggleLoader", false);
                    self.retryJoinInZoomPopup();
                  }
                })
                .catch((error) => {
                  bus.$emit("toggleLoader", false);
                  console.log(error);
                  self.retryJoinInZoomPopup();
                });
            }
          }
        } else {
          alert(self.zoomErrorMsg);
        }
      }
      // }
    },
    retryJoinInZoomPopup() {
      $("#RetryJoinInZoom").modal(
        {
          backdrop: "static",
        },
        "show"
      );
    },
    cancelRetryJoinInZoom() {
      $("#RetryJoinInZoom").modal("hide");
    },
    retryJoinInZoom() {
      $("#RetryJoinInZoom").modal("hide");
      if (self.tempMeeting) {
        self.StartBroadcast(
          self.tempMeeting.meetingId,
          self.tempMeeting.streamingClient
        );
      }
    },
    SendVideoJoinedMail: function (
      ReceiverName,
      ReceiverEmail,
      Title,
      Company,
      usrid,
      chatToId,
      chatToImage
    ) {
      //**** Start EMAIL Video joined Mail To Meeting Receiver

      var obj = JSON.parse(window.localStorage.getItem("my-app"));

      var SenderName = obj.user[0].name;
      var SenderEmail = obj.user[0].Email;

      //if (location.origin.toLowerCase().indexOf("localhost") >= 0) {
      //ReceiverEmail = "vishalakshi.murthy@webspiders.com";
      //}

      var htmlVideojoin = self.GetVideoJoinEmailHtmlBody(
        SenderName,
        SenderEmail,
        ReceiverName,
        Title,
        Company
      );

      if (location.origin.toLowerCase().indexOf("localhost") >= 0) {
        ReceiverEmail = "vishalakshi.murthy@webspiders.com";
      }
      var objEventName;
      if (obj.eventname !== undefined) {
        objEventName = obj.eventname;
      } else {
        objEventName = "";
      }

      var requestData1 = {
        from: objEventName + "<noreply@mail.e2m.live>",
        to: {
          name: ReceiverName,
          email: ReceiverEmail,
        },
        subject: "Meeting alert! " + SenderName + " has started the meeting",
        html: htmlVideojoin,
      };
      self.SentMeetingMail(requestData1);

      self.SentMeetingNotification(
        "joined",
        SenderName,
        chatToImage != "" ? chatToImage : "",
        chatToId
      );
      //**** End EMAIL Video joined Mail To Meeting Receiver
    },

    // Video URL Encryption
    getEncryptedVideoURLParams: function (
      videoParamsEncryptURL,
      VideoBaseURL,
      TokenValidityHours,
      ChannelID,
      UserID,
      SessionTitle,
      clientId,
      callBackFunction
    ) {
      // alert("getEncryptedVideoURLParams");
      console.log(
        "qString - channelName - " +
          ChannelID.toString() +
          " userId- " +
          parseInt(UserID) +
          " validityHours - " +
          parseInt(TokenValidityHours) +
          " isScreen - 0" +
          " sname - " +
          SessionTitle.toString() +
          " clientID - " +
          clientId
      );

      var qString = {
        channelName: ChannelID.toString(),
        userId: parseInt(UserID),
        validityHours: parseInt(TokenValidityHours),
        isScreen: 0,
        sname: SessionTitle.toString(),
        clientId: clientId,
      };

      var encParam = "";
      var videoURL = VideoBaseURL;

      $.ajax({
        url: videoParamsEncryptURL,
        headers: {
          "Content-Type": "application/json",
        },
        beforeSend: function () {
          self.showLoader();
        },
        type: "POST",
        dataType: "json",
        data: JSON.stringify(qString),
        success: function (data) {
          if (typeof data != "undefined") {
            self.hideLoader();
            let lStatusCode = 0;
            lStatusCode = data.status;
            if (lStatusCode == 0) {
              encParam = data.result;
              videoURL = videoURL + "?vt=" + encParam;
              callBackFunction(videoURL, UserID);
              console.log("Get Encrypt URL API Call Success");
            } else {
              self.hideLoader();
              alert("Error initiating video call. Please retry. ");
              //console.log("Encrypted URL not found in API Call");
              //alert("URL decode has been failed before starting OnAir");
            }
          } else {
            self.hideLoader();
            alert("Error initiating video call. Please retry. ");
            //console.log("Encrypted URL not found in API Call");
            //alert("URL decode has been failed before starting OnAir");
          }
        },
        error: function () {
          self.hideLoader();
          alert("Error initiating video call. Please retry. ");
          //console.log("Error in Get Encrypt URL API Call");
          //alert("URL decode has been failed before starting OnAir");
        },
      });
    },
    showLoader: function () {
      if ($("#divLoading") != null) {
        $("#divLoading").show();
      }
    },
    hideLoader: function () {
      //if (timerLoader != null) {
      clearTimeout(this.timerLoader);
      // alert("outside");
      if ($("#divLoading") != null) {
        //alert("inside");
        $("#divLoading").hide();
      }
      //}
    },
    readCookieForVideo: function (name) {
      var nameEQ = encodeURIComponent(name) + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0)
          return decodeURIComponent(c.substring(nameEQ.length, c.length));
      }
      return null;
    },
    AcceptedMeetingEmailHtml: function (
      SenderName,
      ReceiverName,
      Email,
      Title,
      Company,
      dStartDateTime, //MeetingStartDateTime
      Message
    ) {
      var Meetingurl = "https://" + location.host.toLowerCase() + "/mymeetings";
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      var ClientName = obj.client[0].name;

      let htmlmailbody = "<html><body>";
      htmlmailbody += "<p> Hello " + ReceiverName + ", </p>";
      htmlmailbody += "<p>Meeting request is accepted</p>";
      htmlmailbody += "<table>";
      htmlmailbody += "<tr>";
      htmlmailbody += "<td>Meeting With: </td>";
      htmlmailbody += "<td>" + SenderName + "</td>";
      htmlmailbody += "</tr>";

      if (Title != "" && Title != "undefined") {
        htmlmailbody += "<tr>";
        htmlmailbody += "<td>Title: </td>";
        htmlmailbody += "<td>" + Title + "</td>";
        htmlmailbody += "</tr>";
      }

      if (Company != "" && Company != "undefined") {
        htmlmailbody += "<tr>";
        htmlmailbody += "<td>Company:</td>";
        htmlmailbody += "<td>" + Company + "</td>";
        htmlmailbody += "</tr>";
      }
      htmlmailbody += "<tr>";
      htmlmailbody += "<td>Email:</td>";
      htmlmailbody += "<td>" + Email + "</td>";
      htmlmailbody += "</tr>";
      // htmlmailbody += "<tr>";
      // htmlmailbody += "<td>When</td>";
      //
      // htmlmailbody += "<td>" + moment(dStartDateTime,"DD-MM-YYYY HH:mm A").format(
      //     "dddd, MMMM Do YYYY, h:mm a"
      //   ); + " ("+ obj.tzone +" )</td>";
      // htmlmailbody += "</tr>";
      htmlmailbody += "<tr>";
      htmlmailbody += "<td>Message:</td>";
      htmlmailbody += "<td>" + Message + "</td>";
      htmlmailbody += "</tr>";
      htmlmailbody += "</table> ";
      htmlmailbody += "<br/>";
      htmlmailbody +=
        "<p>Visit <a href='" +
        Meetingurl +
        "'>" +
        Meetingurl +
        "</a> to check the status of all your meetings.</p>";
      htmlmailbody += "<br/>";
      htmlmailbody += "<p>Team " + ClientName + "</p>";
      htmlmailbody += "</body></ html>";
      return htmlmailbody;
    },
    CancelledMeetingEmailHtml: function (
      SenderName,
      ReceiverName,
      Email,
      Title,
      Company,
      dStartDateTime, //MeetingStartDateTime
      Message
    ) {
      var Meetingurl = "https://" + location.host.toLowerCase() + "/mymeetings";
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      var ClientName = obj.client[0].name;

      let htmlmailbody = "<html><body>";
      htmlmailbody += "<p> Hello " + ReceiverName + ", </p>";
      htmlmailbody += "<p>Meeting request is cancelled</p>";
      htmlmailbody += "<table>";
      htmlmailbody += "<tr>";
      htmlmailbody += "<td>Meeting With: </td>";
      htmlmailbody += "<td>" + SenderName + "</td>";
      htmlmailbody += "</tr>";

      if (Title != "" && Title != "undefined") {
        htmlmailbody += "<tr>";

        htmlmailbody += "<td>Title: </td>";
        htmlmailbody += "<td>" + Title + "</td>";
        htmlmailbody += "</tr>";
      }

      if (Company != "" && Company != "undefined") {
        htmlmailbody += "<tr>";
        htmlmailbody += "<td>Company:</td>";
        htmlmailbody += "<td>" + Company + "</td>";
        htmlmailbody += "</tr>";
      }
      htmlmailbody += "<tr>";
      htmlmailbody += "<td>Email:</td>";
      htmlmailbody += "<td>" + Email + "</td>";
      htmlmailbody += "</tr>";
      htmlmailbody += "<tr>";
      // htmlmailbody += "<td>When</td>";
      //
      //  htmlmailbody += "<td>" + moment(dStartDateTime,"DD-MM-YYYY HH:mm A").format(
      //     "dddd, MMMM Do YYYY, h:mm a"
      //   ); + " ("+ obj.tzone +" )</td>";
      // htmlmailbody += "</tr>";
      htmlmailbody += "<tr>";
      htmlmailbody += "<td>Message:</td>";
      htmlmailbody += "<td>" + Message + "</td>";
      htmlmailbody += "</tr>";
      htmlmailbody += "</table> ";
      htmlmailbody += "<br/>";

      if (ReceiverName != obj.user[0].name) {
        htmlmailbody +=
          " Please note: You may request for another meeting at different date and time.";
        htmlmailbody += "<br/>";
      }

      htmlmailbody +=
        "<p>Visit <a href='" +
        Meetingurl +
        "'>" +
        Meetingurl +
        "</a> to check the status of all your meetings.</p>";
      htmlmailbody += "<br/>";
      htmlmailbody += "<p>Team " + ClientName + "</p>";
      htmlmailbody += "</body></ html>";
      return htmlmailbody;
    },
    GetVideoJoinEmailHtmlBody: function (
      SenderName,
      SenderEmail,
      ReceiverName,
      Title,
      Company
    ) {
      var Meetingurl = "https://" + location.host.toLowerCase() + "/mymeetings";
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      var ClientName = obj.client[0].name;

      let htmlmailbody = "<html><body>";
      htmlmailbody += "<p>Hello " + ReceiverName + ", </p>";
      htmlmailbody += "<p>" + SenderName + " has joined the meeting!</p>";
      htmlmailbody +=
        "Visit " +
        Meetingurl +
        ' and click on the "Join Meeting" button under Confirmed tab now!';
      htmlmailbody += "<table>";
      htmlmailbody += "<tr>";
      htmlmailbody += "<td>Meeting With: </td>";
      htmlmailbody += "<td>" + SenderName + "</td>";
      htmlmailbody += "</tr>";

      if (Title != "" && Title != "undefined") {
        htmlmailbody += "<tr>";
        htmlmailbody += "<td>Title: </td>";
        htmlmailbody += "<td>" + Title + "</td>";
        htmlmailbody += "</tr>";
      }

      if (Company != "" && Company != "undefined") {
        htmlmailbody += "<tr>";
        htmlmailbody += "<td>Company:</td>";
        htmlmailbody += "<td>" + Company + "</td>";
        htmlmailbody += "</tr>";
      }
      htmlmailbody += "<tr>";
      htmlmailbody += "<td>Email:</td>";
      htmlmailbody += "<td>" + SenderEmail + "</td>";
      htmlmailbody += "</tr>";
      htmlmailbody += "</table> ";
      htmlmailbody += "<br/>";
      htmlmailbody += "<p>Team " + ClientName + "</p>";
      htmlmailbody += "</body></ html>";
      return htmlmailbody;
    },
    SentMeetingMail: function (EMailObj) {
      console.log(JSON.stringify(EMailObj));

      $.ajax({
        url: self.EmailURL,
        headers: {
          "Content-Type": "application/json",
        },
        type: "POST",
        dataType: "json",
        processData: false,
        data: JSON.stringify(EMailObj),
        beforeSend: function () {},
        success: function (data) {
          if (data) {
            console.log(JSON.stringify(data));
          } else {
            console.log("null");
          }
        },

        error: function () {
          console.log("Error in mail Sent");
        },
      });
    },
    SentMeetingNotification: function (
      type,
      SenderName,
      SenderProfilePictureURL,
      ReceiverId
    ) {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));

      var objEventName;
      if (obj.eventname !== undefined) {
        objEventName = obj.eventname;
      } else {
        objEventName = "";
      }

      var Meetingurl = location.host.toLowerCase() + "/mymeetings";
      var vardeviceToken = "";
      var varFirebaseServerKey = "";
      var NotificationSettings = [];

      var docMSRef = db
        .collection(obj.eventcollectionname)
        .doc("MeetingList")
        .collection("Settings")
        .doc("MeetingSettings");

      docMSRef.get().then(function (doc) {
        if (doc.exists) {
          var MObj = new Object();
          MObj.NotificationMessage = doc.data().NotificationMessage;
          NotificationSettings.push(MObj.NotificationMessage);
          //

          var message;
          var messageName;
          var notifybefore;
          var NotifyTypeIndex;
          var PushNotificationIcon = "/images/success.png";

          if (type == "newrequest") {
            if (NotificationSettings.length >= 1) {
              message = NotificationSettings[0][1].Message.replace(
                "{{MeetingRequestor}}",
                SenderName
              );

              messageName = NotificationSettings[0][1].Name;
              NotifyTypeIndex = 1;
              notifybefore = 30;
              PushNotificationIcon = "/images/success.png";
            }
          }
          if (type == "joined") {
            if (NotificationSettings.length >= 1) {
              message = NotificationSettings[0][2].Message.replace(
                "{{MeetingJoinee}}",
                SenderName
              ).replace("{{MyMeetings}}", Meetingurl);

              messageName = NotificationSettings[0][2].Name;
              NotifyTypeIndex = 2;
              notifybefore = 30;
              PushNotificationIcon = "/images/started.png";
            }
          }

          if (type == "cancelled") {
            if (NotificationSettings.length >= 1) {
              message = NotificationSettings[0][3].Message.replace(
                "{{MeetingReceiver}}",
                SenderName
              );
              messageName = NotificationSettings[0][3].Name;
              NotifyTypeIndex = 3;
              notifybefore = 30;
              PushNotificationIcon = "/images/declined.png";
            }
          }

          if (type == "accepted") {
            if (NotificationSettings.length >= 1) {
              message = NotificationSettings[0][4].Message.replace(
                "{{MeetingReceiver}}",
                SenderName
              );

              messageName = NotificationSettings[0][4].Name;
              NotifyTypeIndex = 4;
              notifybefore = 30;
              PushNotificationIcon = "/images/success.png";
            }
          }

          var NotificationsId = ReceiverId + "_" + new Date().getTime();

          var MdocRef = db
            .collection(obj.eventcollectionname)
            .doc("AttendeeList")
            .collection("Attendees")
            .doc(ReceiverId)
            .collection("Notifications")
            .doc(NotificationsId);
          //
          MdocRef.get()
            .then(function (doc) {
              if (!doc.exists) {
                var docObj = new Object();
                docObj.Name = SenderName;
                docObj.Initials = self.getInitials(SenderName);
                docObj.ProfilePictureURL = SenderProfilePictureURL;
                docObj.Message = message;
                docObj.Title = messageName;
                docObj.NotifyTypeIndex = NotifyTypeIndex;
                docObj.Module = "Meeting";
                docObj.Time = new Date();
                docObj.ExpireInMinutes = notifybefore;
                docObj.isSeen = "0";
                docObj.CreatedDate = new Date();
                docObj.LastModifiedDate = new Date();

                MdocRef.set(docObj)
                  .then(function () {
                    console.log("Attendees Notifications Created ");

                    //**** Start web push
                    var docNRef = db
                      .collection(obj.eventcollectionname)
                      .doc("SubscribersList")
                      .collection("Subscriptions")
                      .doc(ReceiverId);

                    docNRef.get().then(function (doc) {
                      if (doc.exists) {
                        vardeviceToken = doc.data().DeviceToken;

                        db.collection("OA_UAT")
                          .doc("GeneralSettings")
                          .get()
                          .then(function (doc) {
                            if (doc.exists) {
                              varFirebaseServerKey =
                                doc.data().FirebaseServerKey;

                              console.log(varFirebaseServerKey);

                              $.ajax({
                                type: "POST",
                                url: self.FCMURL, //"https://fcm.googleapis.com/fcm/send",
                                headers: {
                                  Authorization: "key=" + varFirebaseServerKey,
                                  //"AAAAG8IFqjo:APA91bFOKr3FfPU-5AvL7MT3iKTVoibWIiCKGGRW03nXEmfqbyKfdgN_13R9sTV44JgXWsAN-tR4YGN-6UNcPn04otBHPoeC6ST3mf57aouf9BAjKlwv-X79cs4QTBEW7jbCbo1hqV4W",
                                },
                                contentType: "application/json",
                                dataType: "json",
                                data: JSON.stringify({
                                  to:
                                    // "eFubKrT2vBqLcaG9CYHltn:APA91bFUxnztqwgY-NJ5DytxdExZTkFNjFYgIjIWnTU2usuxP8HEmTTuj_cTdECdMxxUGVJtypEm_8Z1nP9LbnckV2CVoWzyKb1n-PysSEze_oen_4qXg2kBngliwJAHS3DUGVw7cJg4",
                                    vardeviceToken,
                                  notification: {
                                    title: objEventName + ": " + messageName,
                                    body: message,
                                    icon: PushNotificationIcon,
                                  },
                                }),
                                success: function (response) {
                                  console.log(
                                    "PushNotifications respone: ",
                                    response
                                  );
                                },
                                error: function (xhr, status, error) {
                                  console.log(xhr);
                                  console.log(status);
                                  console.log(
                                    "Error PushNotifications : ",
                                    error
                                  );
                                },
                              });
                            }
                          });
                      }
                    });
                    //**** End web push
                  })
                  .catch(function (error) {
                    console.error("Error AttendeesNotifications : ", error);
                  });
              }
            })
            .catch(function (error) {
              console.error("Error creating AttendeesNotifications: ", error);
            });
        }
      });
    },
    AddAnalitics: function (btnName, action) {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj !== undefined) {
        var eventName;
        if (obj.eventname !== undefined) {
          eventName = obj.eventname;
        } else {
          eventName = "";
        }
        var actionType = "";
        var actionLabel = "";
        if (action !== "scroll") {
          actionType = btnName.target.tagName.toLowerCase();
          if (btnName.target.getAttribute("data-tag") !== undefined) {
            if (btnName.target.getAttribute("data-tag") === null) {
              return false;
            }
            actionLabel = btnName.target.getAttribute("data-tag");

            if (actionLabel !== "") {
              this.event_collectionName = obj.eventcollectionname;
              analytics.AddUserAction(
                this.event_collectionName,
                eventName,
                location.pathname,
                action,
                actionType,
                actionLabel,
                obj.user[0].id,
                obj.user[0].fname + " " + obj.user[0].lname,
                obj.user[0].Email
              );
            }
          }
        } else {
          this.event_collectionName = obj.eventcollectionname;
          analytics.AddUserAction(
            this.event_collectionName,
            eventName,
            location.pathname,
            action,
            actionType,
            actionLabel,
            obj.user[0].id,
            obj.user[0].fname + " " + obj.user[0].lname,
            obj.user[0].Email
          );
        }
      }
    },
    onClickHandler(event) {
      // event.target is the clicked element object
      this.AddAnalitics(event, "click");
    },
    TimezoneUpdate: function (MeetingId) {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      var docRef = db
        .collection(obj.eventcollectionname)
        .doc("MeetingList")
        .collection("Meetings")
        .doc(MeetingId);
      docRef.get().then(function (doc) {
        if (doc.exists) {
          if (doc.data().ReciverTimeZone === "") {
            db.collection(obj.eventcollectionname)
              .doc("MeetingList")
              .collection("Meetings")
              .doc(MeetingId)
              .update({
                ReciverTimeZone: moment.tz.guess(),
              })
              .then(function () {});
          }
        }
      });
    },
    getMeetingList: function () {
      const obj = JSON.parse(window.localStorage["my-app"]);
      let headers = {
        Authorization: "Bearer " + self.getSessionToken(),
        "content-type": "application/json",
      };
      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: obj.client[0].id,
          eventId: obj.eventid,
        },
      };
      axios
        .post(
          self.APIs.MeetingAPIConfig.GetMeetingList,
          JSON.stringify(requestData),
          {
            headers: headers,
          }
        )
        .then((response) => {
          var res = response.data;
          self.attendeeData = [];
          var ConfirmCtr = 0;
          var ReqSentCtr = 0;
          var ReqRecCtr = 0;
          $("#spConfirm").text("");
          $("#spReqSent").text("");
          $("#spReqRec").text("");
          //console.log(res);
          var allArray = [
            ...res.result.Pending,
            ...res.result.Accepted,
            ...res.result.Canceled,
            ...res.result.Rejected,
            ...res.result.FYA,
          ];

          allArray = allArray.reduce(function (item, e1) {
            var matches = item.filter(function (e2) {
              return e1.MeetingId == e2.MeetingId;
            });
            if (matches.length == 0) {
              item.push(e1);
            }
            return item;
          }, []);

          // if (obj.MeetingSettings[0].ByTimezone === true) {
          //   self.bindMeetingListwithtimezone(allArray);
          // } else {
          //   self.bindMeetingListwithoutTimezone(allArray);
          // }
          //self.bindMeetingListwithoutTimezone(allArray);
          self.bindMeetingListwithtimezone(allArray);
          self.attendeeData = self.attendeeData.sort(function compare(a, b) {
            //parseInt(new Date(events[i].EventStartDateTime).getTime() / 1000)
            var dateA = parseInt(new Date(a.StartDateTime).getTime() / 1000);
            var dateB = parseInt(new Date(b.StartDateTime).getTime() / 1000);
            return dateA - dateB;
          });

          let i;
          for (i = 0; i <= self.attendeeData.length - 1; i++) {
            if (
              (self.attendeeData[i].ReceiverId == obj.user[0].id ||
                self.attendeeData[i].SenderId == obj.user[0].id) &&
              self.attendeeData[i].Status == "Accepted"
            ) {
              ConfirmCtr++;
            }
            if (self.attendeeData[i].SenderId == obj.user[0].id) {
              ReqSentCtr++;
            }
            if (self.attendeeData[i].ReceiverId == obj.user[0].id) {
              ReqRecCtr++;
            }
          }
          self.confirmCount = ConfirmCtr;
          self.requestSentCount = ReqSentCtr;
          self.requestReceivedCount = ReqRecCtr;

          $("#spConfirm").text("(" + ConfirmCtr + ")");
          $("#spReqSent").text("(" + ReqSentCtr + ")");
          $("#spReqRec").text("(" + ReqRecCtr + ")");
          //console.log(self.attendeeData);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    acceptMeeting: function (meetingid) {
      //$(e.target).html("...");
      self.setMeetingInProcess(meetingid, "accept", true);
      const obj = JSON.parse(window.localStorage["my-app"]);
      let headers = {
        Authorization: "Bearer " + self.getSessionToken(),
        "content-type": "application/json",
      };
      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: obj.client[0].id,
          eventId: obj.eventid,
        },
        data: {
          MeetingId: meetingid,
        },
      };

      axios
        .post(self.APIs.MeetingAPIConfig.AcceptMeeting, requestData, {
          headers: headers,
        })
        .then((response) => {
          console.log(response);
          //$(e.target).html(self.$t("mymeetings.joinmeeting"));
          if (response.data) {
            if (response.data.status == 0) {
              self.showSnackbar(
                "Meeting accepted successfully.",
                "info",
                "top"
              );
            } else {
              if (response.data.status == -13) {
                self.showSnackbar(
                  "There is a meeting booked already in this time slot! ",
                  "error",
                  "top"
                );
              } else {
                self.showSnackbar(response.data.msg, "error", "top");
              }
            }
          }
          //self.getMeetingList();
          self.setMeetingInProcess(meetingid, "accept", false);
        })
        .catch((error) => {
          self.showSnackbar("Request failed.", "error", "top");
          self.setMeetingInProcess(meetingid, "accept", false);
          //$(e.target).html(self.$t("mymeetings.joinmeeting"));
          console.log(error);
        });
    },
    rejectMeeting: function (meetingid) {
      debugger;
      self.setMeetingInProcess(meetingid, "reject", true);
      //$(e.target).html("...");
      const obj = JSON.parse(window.localStorage["my-app"]);
      let headers = {
        Authorization: "Bearer " + self.getSessionToken(),
        "content-type": "application/json",
      };
      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: obj.client[0].id,
          eventId: obj.eventid,
        },
        data: {
          MeetingId: meetingid,
        },
      };
      axios
        .post(
          self.APIs.MeetingAPIConfig.RejectMeeting,
          JSON.stringify(requestData),
          {
            headers: headers,
          }
        )
        .then((response) => {
          console.log(response);
          //self.getMeetingList();
          if (response.data) {
            if (response.data.status == 0) {
              self.showSnackbar(
                "Meeting rejected successfully.",
                "info",
                "top"
              );
            } else {
              //if (response.data.status == -13) {
              //  self.showSnackbar(
              //    "There is a meeting booked already in this time slot! ",
              //    "error",
              //    "top"
              //  );
              //} else {
              self.showSnackbar(response.data.msg, "error", "top");
              //}
            }
          }
          self.setMeetingInProcess(meetingid, "reject", false);
        })
        .catch((error) => {
          console.log(error);
          self.setMeetingInProcess(meetingid, "reject", false);
        });
    },
    cancelMeeting: function (meetingid) {
      debugger;
      self.setMeetingInProcess(meetingid, "cancel", true);
      //$(e.target).html("...");
      const obj = JSON.parse(window.localStorage["my-app"]);
      let headers = {
        Authorization: "Bearer " + self.getSessionToken(),
        "content-type": "application/json",
      };
      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: obj.client[0].id,
          eventId: obj.eventid,
        },
        data: {
          MeetingId: meetingid,
        },
      };
      axios
        .post(
          self.APIs.MeetingAPIConfig.CancelMeeting,
          JSON.stringify(requestData),
          {
            headers: headers,
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data) {
            if (response.data.status == 0) {
              self.showSnackbar(
                "Meeting cancelled successfully.",
                "info",
                "top"
              );
            } else {
              //if (response.data.status == -13) {
              //  self.showSnackbar(
              //    "There is a meeting booked already in this time slot! ",
              //    "error",
              //    "top"
              //  );
              //} else {
              self.showSnackbar(response.data.msg, "error", "top");
              //}
            }
          }
          //$(e.target).html(self.$t("mymeetings.joinmeeting"));
          self.setMeetingInProcess(meetingid, "cancel", false);
        })
        .catch((error) => {
          console.log(error);
          self.setMeetingInProcess(meetingid, "cancel", false);
        });
    },
    setMeetingInProcess(meetingid, action, status) {
      var meetings = self.attendeeData.filter(function (item) {
        return item.MeetingId == meetingid;
      });
      if (meetings.length > 0) {
        var timeout = 1;
        if (!status) {
          timeout = 3000;
        }
        setTimeout(() => {
          if (action == "accept") {
            meetings[0].acceptInProcess = status;
          } else if (action == "reject") {
            meetings[0].rejectInProcess = status;
          } else if (action == "cancel") {
            meetings[0].cancelInProcess = status;
          }
          self.attendeeData = self.attendeeData.filter(function () {
            return true;
          });
        }, timeout);
      }
    },
    bindMeetingListwithtimezone: function (meetingDoc) {
      let i;
      const obj = JSON.parse(window.localStorage["my-app"]);
      for (i = 0; i <= meetingDoc.length - 1; i++) {
        var meetings = self.attendeeData.filter(function (item) {
          return item.MeetingId == meetingDoc[i].MeetingId;
        });
        if (meetings.length == 0) {
          self.attendeeData.push({
            MeetingId: meetingDoc[i].MeetingId,
            MeetingType: meetingDoc[i].MeetingType,
            StreamingClient: meetingDoc[i].StreamingClient
              ? meetingDoc[i].StreamingClient
              : "Web",
            Host: meetingDoc[i].Host ? meetingDoc[i].Host : [],
            Zoom_Detail: meetingDoc[i].Zoom_Detail
              ? meetingDoc[i].Zoom_Detail
              : null,
            Message: meetingDoc[i].Message ? meetingDoc[i].Message : "",
            Name: meetingDoc[i].Invitee.Name,
            Company: meetingDoc[i].Invitee.Company,
            Title: meetingDoc[i].Invitee.Designation,
            StartDate: moment(meetingDoc[i].Slots[0]).format("ddd D MMM"),
            StartTime: moment(
              self.GetTimeByZone(meetingDoc[i].Slots[0], moment.tz.guess())
            ).format("hh:mm A"),
            StartDateTime: moment(
              self.GetTimeByZone(meetingDoc[i].Slots[0], moment.tz.guess())
            ),
            EndDateTime: moment(
              self.GetTimeByZone(meetingDoc[i].Slots[0], moment.tz.guess())
            ).add(parseInt(obj.MeetingSettings[0].Duration), "minutes"),
            EndTime: moment(
              self.GetTimeByZone(meetingDoc[i].Slots[0], moment.tz.guess())
            ).add(parseInt(obj.MeetingSettings[0].Duration), "minutes"),
            Email: meetingDoc[i].Invitee.Email,
            Image: meetingDoc[i].Invitee.ProfilePictureURL,
            Phone: meetingDoc[i].Invitee.Phone,
            Status: meetingDoc[i].Status,
            ReceiverId: meetingDoc[i].Invitee.AttendeeId,
            SenderId: meetingDoc[i].Requestor.AttendeeId,

            OrganizerId: meetingDoc[i].Requestor.AttendeeId,
            OrganizerEmail: meetingDoc[i].Requestor.Email,
            OrganizerFname: meetingDoc[i].Requestor.FirstName,
            OrganizerLname: meetingDoc[i].Requestor.LastName,
            Organizername: meetingDoc[i].Requestor.Name,
            Organizerprofilepic: meetingDoc[i].Requestor.ProfilePictureURL,
            OrganizerCompany: meetingDoc[i].Requestor.Company,
            OrganizerTitle: meetingDoc[i].Requestor.Designation,

            AttendeeInitials: self.getInitials(meetingDoc[i].Invitee.Name),
            OrganizerAttendeesInitials: self.getInitials(
              meetingDoc[i].Requestor.Name
            ),
            MeetingCurrentStatus: self.getMeetingCurrentStatus(
              moment(meetingDoc[i].Slots[0]).format("YYYY-MM-DDTHH:mm:ss[Z]"),
              moment(meetingDoc[i].Slots[0])
                .add(parseInt(obj.MeetingSettings[0].Duration), "minutes")
                .format("YYYY-MM-DDTHH:mm:ss[Z]")
            ),
            ShowAll: $("#customSwitch1").is(":checked"),
            acceptInProcess: false,
            rejectInProcess: false,
            cancelInProcess: false,
          });
        } else {
          meetings[0].Status = meetingDoc[i].Status;
          meetings[0].MeetingCurrentStatus = self.getMeetingCurrentStatus(
            moment(meetingDoc[i].Slots[0]).format("YYYY-MM-DDTHH:mm:ss[Z]"),
            moment(meetingDoc[i].Slots[0])
              .add(parseInt(obj.MeetingSettings[0].Duration), "minutes")
              .format("YYYY-MM-DDTHH:mm:ss[Z]")
          );
        }
      }
    },
    bindMeetingListwithoutTimezone: function (meetingDoc) {
      let i;
      const obj = JSON.parse(window.localStorage["my-app"]);
      for (i = 0; i <= meetingDoc.length - 1; i++) {
        self.attendeeData.push({
          MeetingId: meetingDoc[i].MeetingId,
          MeetingType: meetingDoc[i].MeetingType,
          Message: meetingDoc[i].Message ? meetingDoc[i].Message : "",
          Name: meetingDoc[i].Invitee.Name,
          Company: meetingDoc[i].Invitee.Company,
          Title: meetingDoc[i].Invitee.Designation,
          StartDate: moment(meetingDoc[i].Slots[0]).format("ddd D MMM"),
          StartTime: moment(meetingDoc[i].Slots[0]).format("hh:mm A"),
          StartDateTime: moment(meetingDoc[i].Slots[0]),
          EndDateTime: moment(meetingDoc[i].Slots[0]).add(
            parseInt(obj.MeetingSettings[0].Duration),
            "minutes"
          ),
          EndTime: moment(meetingDoc[i].Slots[0])
            .add(parseInt(obj.MeetingSettings[0].Duration), "minutes")
            .format("hh:mm A"),
          Email: meetingDoc[i].Invitee.Email,
          Image: meetingDoc[i].Invitee.ProfilePictureURL,
          Phone: meetingDoc[i].Invitee.Phone,
          Status: meetingDoc[i].Status,
          ReceiverId: meetingDoc[i].Invitee.AttendeeId,
          SenderId: meetingDoc[i].Requestor.AttendeeId,

          OrganizerId: meetingDoc[i].Requestor.AttendeeId,
          OrganizerEmail: meetingDoc[i].Requestor.Email,
          OrganizerFname: meetingDoc[i].Requestor.FirstName,
          OrganizerLname: meetingDoc[i].Requestor.LastName,
          Organizername: meetingDoc[i].Requestor.Name,
          Organizerprofilepic: meetingDoc[i].Requestor.ProfilePictureURL,
          OrganizerCompany: meetingDoc[i].Requestor.Company,
          OrganizerTitle: meetingDoc[i].Requestor.Designation,

          AttendeeInitials: self.getInitials(meetingDoc[i].Invitee.Name),
          OrganizerAttendeesInitials: self.getInitials(
            meetingDoc[i].Requestor.Name
          ),
          //moment.utc(new Date(SelDateTime)).format('YYYY-MM-DDTHH:mm:ss+00:00')
          MeetingCurrentStatus: self.getMeetingCurrentStatus(
            moment(meetingDoc[i].Slots[0]).format("YYYY-MM-DDTHH:mm:ss"),
            moment(meetingDoc[i].Slots[0])
              .add(parseInt(obj.MeetingSettings[0].Duration), "minutes")
              .format("YYYY-MM-DDTHH:mm:ss")
          ),
          ShowAll: $("#customSwitch1").is(":checked"),
        });
      }
    },
    AddToGoogleCalendar(data, type) {
      var dtFrom = this.getCalendarDateTime(
        moment.duration(data.StartDateTime._d).asSeconds(),
        "google"
      );
      var dtTo = this.getCalendarDateTime(
        moment.duration(data.EndDateTime._d).asSeconds(),
        "google"
      );
      var name;
      var company;
      var email;
      if (type == 2) {
        name = data.Name;
        company = data.Company;
        email = data.Email;
      } else {
        name = data.Organizername;
        company = data.OrganizerCompany;
        email = data.OrganizerEmail;
      }
      if (data.Message !== "") {
        return (
          "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=" +
          dtFrom +
          "/" +
          dtTo +
          "&text=" +
          "Meeting With " +
          name +
          "&details=" +
          "Meeting With: " +
          name +
          "<br>" +
          "Company: " +
          company +
          "<br>" +
          "Email: " +
          email +
          "<br>" +
          "Message: " +
          data.Message +
          "<br>" +
          "Visit " +
          location.origin.toLowerCase() +
          "/mymeetings" +
          " to check the status of all your meetings."
        );
      } else {
        return (
          "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=" +
          dtFrom +
          "/" +
          dtTo +
          "&text=" +
          "Meeting With " +
          name +
          "&details=" +
          "Meeting With: " +
          name +
          "<br>" +
          "Company: " +
          company +
          "<br>" +
          "Email: " +
          email +
          "<br>" +
          "Visit " +
          location.origin.toLowerCase() +
          "/mymeetings" +
          " to check the status of all your meetings."
        );
      }
    },
    AddToOutlookCalendar(data, type) {
      var dtFrom = this.getCalendarDateTime(
        moment.duration(data.StartDateTime._d).asSeconds(),
        "outlook"
      );
      var dtTo = this.getCalendarDateTime(
        moment.duration(data.EndDateTime._d).asSeconds(),
        "outlook"
      );
      var name;
      var company;
      var email;
      if (type == 2) {
        name = data.Name;
        company = data.Company;
        email = data.Email;
      } else {
        name = data.Organizername;
        company = data.OrganizerCompany;
        email = data.OrganizerEmail;
      }
      var linkUrl = "";
      if (data.Message != "") {
        linkUrl =
          "start=" +
          dtFrom +
          "&end=" +
          dtTo +
          "&title=" +
          "Meeting With " +
          name +
          "&description=" +
          "Email: " +
          email +
          " Message: " +
          data.Message +
          " Visit " +
          location.origin.toLowerCase() +
          "/mymeetings" +
          " to check the status of all your meetings." +
          "&service=outlook";
        linkUrl =
          "https://www.addevent.com/dir/?client=amFHciuoCzziVYGDHmDp105401&" +
          linkUrl;
        return linkUrl;
      } else {
        linkUrl =
          "start=" +
          dtFrom +
          "&end=" +
          dtTo +
          "&title=" +
          "Meeting With " +
          name +
          "&description=" +
          "Meeting With: " +
          name +
          " Company: " +
          company +
          " Email: " +
          email +
          " Visit " +
          location.origin.toLowerCase() +
          "/mymeetings" +
          " to check the status of all your meetings." +
          "&service=outlook";
        linkUrl =
          "https://www.addevent.com/dir/?client=amFHciuoCzziVYGDHmDp105401&" +
          linkUrl;

        // linkUrl =
        //   "https://www.addevent.com/dir/?client=amFHciuoCzziVYGDHmDp105401" +
        //   "&subject=" +
        //   "Meeting With " +
        //   name +
        //   "&body=" +
        //   "Meeting With: " +
        //   name +
        //   "<br>" +
        //   "Company: " +
        //   company +
        //   "<br>" +
        //   "Email: " +
        //   email +
        //   "<br>" +
        //   "Visit " +
        //   location.origin.toLowerCase() +
        //   "/mymeetings" +
        //   " to check the status of all your meetings.";
        // "&startdt=" +
        //   dtFrom +
        //   "&enddt=" +
        //   dtTo +
        //   "&uid=1a45242b-5205-4f37-815a-84ab74990640&allday=false&path=/calendar/action/compose";
        return linkUrl;
      }
    },
  },
  beforeDestroy() {
    if (interval) {
      clearInterval(interval);
      interval = null;
    }
  },
  beforeRouteLeave(to, from, next) {
    if (interval) {
      clearInterval(interval);
      interval = null;
    }
    next(true);
  },
  async mounted() {
    var data = {
      showUserWelcomeLoader: false,
    };

    bus.$emit("setUserWelcomeLoader", data);
    $(".modal-backdrop").hide();
    if (screen.width >= 768 && screen.width <= 1024) {
      common.checkAppDownloadScreenByDevice("ipad");
    } else if (screen.width < 767) {
      common.checkAppDownloadScreenByDevice("mobile");
    }
    common.toggleTopMenu(true);
    common.toggleLeftMenu(true);
    //$("#topmenu").show();

    //$("#leftmenu").show();

    // if ($("#ulLeftMenu li").length > 0) {
    //   $("#leftMenuParent").show();
    //   $("#leftmenu").show();
    // } else {
    //   $("#leftMenuParent").hide();
    //   $("#leftmenu").hide();
    // }
    $("#btnAddUserView").click();
    var obj = JSON.parse(window.localStorage.getItem("my-app"));
    //-------------dynamic font selection --------------------------------------
    //-------------dynamic font selection --------------------------------------
    if (obj.EventFont != undefined) {
      if (obj.EventFont.length > 0) {
        //
        var urlpath = "";
        if (obj.EventFont[0].FontPath != "") {
          if (obj.EventFont[0].FontFamily != "") {
            urlpath = obj.EventFont[0].FontPath;

            var newStyle = document.createElement("style");
            newStyle.appendChild(
              document.createTextNode(
                "\
@font-face {\
    font-family: " +
                  obj.EventFont[0].FontFamily +
                  ";\
    src:" +
                  urlpath +
                  " ;\
}\
"
              )
            );

            document.head.appendChild(newStyle);

            $(
              "<style>* { font-family: '" +
                obj.EventFont[0].FontFamily +
                "' !important }</style>"
            ).appendTo("head");
          }
        } else {
          $("<style>* { font-family: 'Roboto' !important }</style>").appendTo(
            "head"
          );
        }
      }
    }
    //-------------dynamic font selection --------------------------------------
    //-------------dynamic font selection --------------------------------------
    //-------Page Title-------------
    self.headerText = "Appointments";
    db.collection(obj.eventcollectionname)
      .doc("Menu")
      .get()
      .then((doc) => {
        var data = doc.data();
        $.each(data.AllMenu, function (key, value) {
          if (value.GroupID != 99) {
            if (value.Name == "OneToOneMeeting") {
              if (self.$store.state.locale == "English") {
                self.headerText = value.DisplayLabel;
              } else if (self.$store.state.locale == "German") {
                self.headerText = value.DisplayLabel_de;
              } else if (self.$store.state.locale == "French") {
                self.headerText = value.DisplayLabel_fr;
              } else if (self.$store.state.locale == "Chinese") {
                self.headerText = value.DisplayLabel_zh;
              } else if (self.$store.state.locale == "Spanish") {
                self.headerText = value.DisplayLabel_es;
              } else {
                self.headerText = value.DisplayLabel;
              }
            }
            if (value.MenuID == 1022) {
              self.LiveStageURL = value.PageUrl ? value.PageUrl : "/livestage";
            }
          }
        });
        $.each(data.LeftMenu, function (key, value) {
          if (value.GroupID != 99) {
            if (value.Name == "OneToOneMeeting") {
              if (self.$store.state.locale == "English") {
                self.headerText = value.DisplayLabel;
              } else if (self.$store.state.locale == "German") {
                self.headerText = value.DisplayLabel_de;
              } else if (self.$store.state.locale == "French") {
                self.headerText = value.DisplayLabel_fr;
              } else if (self.$store.state.locale == "Chinese") {
                self.headerText = value.DisplayLabel_zh;
              } else if (self.$store.state.locale == "Spanish") {
                self.headerText = value.DisplayLabel_es;
              } else {
                self.headerText = value.DisplayLabel;
              }
            }
            if (value.MenuID == 1022) {
              self.LiveStageURL = value.PageUrl ? value.PageUrl : "/livestage";
            }
          }
        });
        $(document).attr("title", self.headerText + " - " + obj.eventname);
      });

    //
    $(document).attr("title", self.headerText + " - " + obj.eventname);

    var brandingData;
    try {
      brandingData = await self.getBrandingJSONDetails(
        obj.eventcollectionname + "/Branding/Branding.json"
      );
      if (brandingData.data != undefined) {
        if (brandingData.data.EventInfo != undefined) {
          if (brandingData.data.EventInfo.BodyTextColor != undefined) {
            self.textColor = brandingData.data.EventInfo.BodyTextColor;
          } else {
            self.textColor = "black";
          }
        } else {
          self.textColor = "black";
        }
        console.log("BodyTextColor :- " + self.textColor);
        $("#headerText").css("color", self.textColor);
        $("#subHeaderText").css("color", self.textColor);
        // $(":root").css("--event-body-text-color", self.textColor);
        // $(":root").css("--event-tab-color", self.textColor);
        // $(":root").css("--event-active-tab-color", self.textColor);
      }
    } catch (e) {
      console.log("Error in Branding Json Fetch--", e);
    }

    //---------------------------------------------------
    //-------------------FAVICONJOB------------------------------------------------------------
    //
    if (obj.branding[0].favicon != undefined) {
      if (obj.branding[0].favicon != "") {
        var link =
          document.querySelector("link[rel*='icon']") ||
          document.createElement("link");
        link.type = "image/x-icon";
        link.rel = "shortcut icon";
        link.href = obj.branding[0].favicon;
        document.getElementsByTagName("head")[0].appendChild(link);
      }
    }
    //----------------------------------------------------------------------------------
    $("#divBannerTop").css("background-color", obj.EventBranding[0].topBar);
    $("#sectionId").css(
      "background-image",
      "url(" + obj.EventBranding[0].eventBGImage + ")"
    );
    $("#divnomeetings").hide();
    self.attendeeData = [];
    self.setFirebaseAppsettings();

    self.getMeetingList();
    //self.displayAttendees();
    //self.scroll();
    //alert(interval);
    if (interval) {
      clearInterval(interval);
      interval = null;
    }
    interval = setInterval(() => {
      //alert(interval+" in");
      self.getMeetingList();
    }, 5000);

    //-------Search part------------------------------------------------
    $("#InputSearch").keyup(function () {
      //
      $("#spnHeaderText").html("");
      // Retrieve the input field text and reset the count to zero
      var filter = $(self).val(),
        count = 0;
      // Loop through the comment list
      $("#divMainiRow div").each(function () {
        let self = self;
        // If the list item does not contain the text phrase fade it out
        if ($(self).text().search(new RegExp(filter, "i")) < 0) {
          $(self).hide();
          // Show the list item if the phrase matches and increase the count by 1
        } else {
          $(self).show();

          count++;
        }
      });
      if (count <= 0) {
        $("#spnHeaderText").html("No matches found");
      } else {
        $("#spnHeaderText").html("");
      }
    });
    //
    $("#listing-view").click(function () {
      //alert("click");
      $(".meeding-grid ul li").removeClass("active");
      $(this).addClass("active");
      $(".meeting-box-hld").addClass("listing-view-box");
    });
    $("#grid-view").click(function () {
      $(".meeding-grid ul li").removeClass("active");
      $(this).addClass("active");
      $(".meeting-box-hld").removeClass("listing-view-box");
    });

    //---------------------------------------------------
  },
};
</script>   
<style>
.session-list-wrapper .OA_UAT_C1637559892895E1637575885834.nav-tabs .nav-link {
  /* color: #696969; */
  color: #fff !important;
  opacity: 0.6;
}

.session-list-wrapper
  .OA_UAT_C1637559892895E1637575885834.nav-tabs
  .nav-link.active {
  /* color: #696969; */
  color: #fff !important;
  opacity: 1;
}
</style>
<style lang="scss" scoped>
.meeting-box-hld:empty {
  display: none;
}
.accept-btn {
  border: 1px solid #1dc190;
  color: #1dc190;
}
button.btn-rounded.cancle-circle {
  border: 1px solid #f2f2f2;
  color: gray;
}

.dvEnded {
  display: none;
}

.dvtoShow {
  display: block;
}
.no-meeting-paragraph {
  font-weight: 400;
  font-size: 14px;
  color: #000;
  margin: 0px !important;
  padding: 10px 21px;
  background: rgba(255, 255, 255, 0.6);
}
.no-meeting-text {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  position: relative;
}
.no-meeting-paragraph span:hover {
  text-decoration: underline;
}
.icon-bookmeeting {
  position: relative;
  padding: 12px 15px 12px 48px !important;
  border: 2px solid #00a982;
  font-weight: bold;
}
.icon-bookmeeting:hover {
  background: #fff !important;
  color: #00a982;
}
.icon-bookmeeting:before {
  content: "";
  position: absolute;
  display: inline-block;
  top: 50%;
  transform: translateY(-50%);
  background-image: url("../assets/Images/icons/my-meeting-white.svg");
  background-repeat: no-repeat;
  width: 25px;
  height: 25px;
  right: auto;
  left: 15px;
}
.icon-bookmeeting:hover:before {
  background-image: url("../assets/Images/icons/my-meeting-white-blue.svg");
}
.meeting-name {
  width: 30%;
}
.meeting-status .session-status {
  width: 18%;
}
.j-meeting-btn {
  min-width: 100px;
}
.meeting-time-zone {
  text-align: left;
  color: #8b8b8b;
}
.meeting-time-zone:before {
  content: "\f0ac";
  font: normal normal normal 16px/1 FontAwesome;
  height: 15px;
  width: 15px;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  padding-right: 5px;
}
@media only screen and (min-width: 1366px) and (max-width: 1500px) {
  .meeting-status .session-status[data-v-55f839c4] {
    width: 24%;
  }
}
</style>
